import React, { useEffect, useState, useContext, useMemo } from "react";
import ProgressTracker from "../../components/progressTracker";
import MidwestDentalProgressTracker from "../../components/progressTracker/MidwestDentalProgressTracker";
import MidwestDentalEntryPage from "./MidwestDentalEntryPage";
import MidwestDentalDisclaimerScreen from "./MidwestDentalDisclaimerScreen";
import MidwestDentalThankYouScreen from "./MidwestDentalThankYouScreen";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import {
  getJourneyDataForUsers,
  getFormDataForUsers,
  getStandardFormData,
  getJourneyDataForInstanceId,
  updateJourneyDataForInstanceId,
  submitJourneyFortriggers,
} from "../../utils/form";
import FormRendererContext from "../../services/context/FormRendererContext";
import FormRenderer from "../formRenderer";
import FormRendererNew from "../formRendererNew";
import StripeCheckout from "../PaymentElement/stripePayment";
import "./JourneyRenderer.scss";
import "./MidwestDental.scss";
import Loader from "../../components/common/loader";
import SchedulerWidget from "../schedulerWidget";
import ModalBox from "../../components/common/modal";
import { themes } from "../../utils/theme";
import LandingPage from "../landing";
import LoginDetailsPage from "../loginDetailsCollector";
import LoginPage from "../login";
import NewSchedulerWidget from "../newSchedulerWidget";
import ThemeSelectorContextProvider from "../../services/context/ThemeSelectorContextProvider";
import ThemeSelectorContext from "../../services/context/ThemeSelectorContext";
import cpapLogo from "../../assets/cpap.com_logo_green.png";
import {
  callAthenaGetApi,
  callAthenaPostApi,
  callAthenaPutApi,
} from "../../utils/athena";
import axios from "axios";
import SchedulerWidgetForSynaptrxDemo from "../schedulerWidgetForSynaptrxDemo";
import SchedulerWidgetForReschedule from "../schedulerWidgetForReschedule";
import ameriGasLogo from "../../assets/AmeriGas-logo.png";
import dayjs from "dayjs";
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  // bgcolor: 'background.paper hjdsgbfuhds kjdhiudh',
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

const ErrorModal = ({ show, message, countdownValue }) => {
  if (!show) return null;

  return (
    <ModalBox
      showIcon={false}
      openModal={show}
      leftButtonText={""}
      rightButtonText={""}
      showButtons={false}
      title={"Error"}
      SubTitle={
        <>
          <p className="text-center">{message}</p>
          <p className="mt-2 text-center">
            Redirecting in {countdownValue} seconds...
          </p>
        </>
      }
      hideClose={true}
    />
  );
};

const journeyIdsForStatusCheck = [
  "6722650a5b3a1419fb71eda0",
  "672266365b3a1419fb71ede0",
  "6724e6a014a3e05197fd8b01",
  "6724e68514a3e05197fd8aff",
  "6724e6ab14a3e05197fd8b02",
  "6724e69114a3e05197fd8b00",
  "67100fd2ed976ad58926ecb0",
  "6710106ced976ad58926ecb1",
  "67101074ed976ad58926ecb2",

  "673ae4ae413351c0414fd14f",
  "68133d668855c40cde885f74",
  "685257084ef9cc55588fb845",
  "6819b596c4f18e73b7d06dba",
  "673ae4b7413351c0414fd150",
  "673ae4c0413351c0414fd151",
  "673ae4d8413351c0414fd152",
  "681353648855c40cde885f76",
  "6852579e4ef9cc55588fb847",
  "6819b63ec4f18e73b7d06dc2",
  "673ae4e7413351c0414fd153",
  "673ae4f3413351c0414fd154",
  "673ae4fe413351c0414fd155",
  "681351d18855c40cde885f75",
  "685257594ef9cc55588fb846",
  "6819b5e4c4f18e73b7d06dbe",
  "673ae50a413351c0414fd156",
  "673ae514413351c0414fd157",
];

const cancelAppointmentJourneys = [
  "6722650a5b3a1419fb71eda0",
  "6724e6a014a3e05197fd8b01",
  "6724e6ab14a3e05197fd8b02",
  "673ae4fe413351c0414fd155",
  "681351d18855c40cde885f75",
  "685257594ef9cc55588fb846",
  "6819b5e4c4f18e73b7d06dbe",
  "673ae50a413351c0414fd156",
  "673ae514413351c0414fd157",
];
const JourneyRenderer = () => {
  const { journeyId } = useParams();
  const { journeyInstanceId } = useParams();

  const [steps, setSteps] = useState([]);
  const [activeStep, setActiveSteps] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [loaderMessage, setLoaderMessage] = useState("");
  const [journeySchema, setJourneySchema] = useState(null);
  const [openConfirmationModal, setOpenConfirmationModal] = useState(false);
  const [firstPageFirstFormID, setFirstPageFirstFormID] = useState(null);
  const [inActiveAppointment, setInActiveAppointment] = useState(false);
  const [schedulerIdFromJourneySchema, setSchedulerIdFromJourneySchema] =
    useState(null);
  const [journeyTriggers, setJourneyTriggers] = useState([]);
  const [journeyQueryParams, setJourneyQueryParams] = useState([]);

  // Add new state variables for the error modal
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [countdownValue, setCountdownValue] = useState(5);
  const [showAlternaSleepPopup, setShowAlternaSleepPopup] = useState(false);
  const [showMidwestRedirectPopup, setShowMidwestRedirectPopup] =
    useState(false);
  const [journeyConfigs, setJourneyConfigs] = useState(null);
  const [showEntryPage, setShowEntryPage] = useState(true);
  const [showDisclaimerScreen, setShowDisclaimerScreen] = useState(false);
  const [showMidwestThankYou, setShowMidwestThankYou] = useState(false);
  const [disclaimerConfig, setDisclaimerConfig] = useState(null);
  const [midwestNavigationStack, setMidwestNavigationStack] = useState([
    "entry",
  ]);
  const [hasShownMidwestDisclaimer, setHasShownMidwestDisclaimer] =
    useState(false);

  const {
    journeyData,
    setJourneyData,
    setCompleteJourneyAnswers,
    setQnABodyForTriggers,
    activeScreenID,
    setActiveScreenID,
    activeScreenPageID,
    setActiveScreenPageID,
    activeComponent,
    setActiveComponent,
    activeFormPage,
    setActiveFormPage,
    components,
    appointmentData,
    setAppointmentData,
    setAnswerData,
    answerData,
    setJourneyId,
    setAmount,
    setPatientIdFromQP,
    setAppointmentIdFromQP,
    setHashIdFromQP,
    setProvider_id,
    setDepartment_id,
    setReason_id,
    deviceType,
    setDeviceType,
    setPatientTZ,
    setSocialKeys,
    setInsuranceCollectedStatus,
    setPaymentCollectedStatus,
    setScheduler_id,
    setHBxFirstName,
    setHBxLastName,
    setHBxEmail,
    setHBxDob,
    hashFromQP,
    setHashFromQP,
    setPatient_id,
    qnABodyForTriggers,
    setJourneyInstanceId,
    journeyContext,
    setJourneyContext,
    workflowContext,
    setWorkflowContext,
    setThankYouMessage,
    setJourneyConfigsGlobal,
    setJourneyStatus,
    setIsJourneyReadOnly,
  } = useContext(FormRendererContext);

  const { theme, setTheme } = useContext(ThemeSelectorContext);

  let navigate = useNavigate();

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const queryParamsObject = Object.fromEntries(queryParams);

  const callAthenaApisJourneyIds = [
    "67100fd2ed976ad58926ecb0",
    "6710106ced976ad58926ecb1",
    "67101074ed976ad58926ecb2",
    "673ae4ae413351c0414fd14f",
    "68133d668855c40cde885f74",
    "685257084ef9cc55588fb845",
    "6819b596c4f18e73b7d06dba",
    "673ae4b7413351c0414fd150",
    "673ae4c0413351c0414fd151",
  ];

  const patientId = queryParams.get("patientId");
  const appointmentId = queryParams.get("appointmentId");
  const hashId = queryParams.get("id");
  const hash = queryParams.get("hash");

  setPatientIdFromQP(patientId);
  setAppointmentIdFromQP(appointmentId);
  setHashIdFromQP(hashId);
  setHashFromQP(hash);

  useEffect(() => {
    const updateDeviceType = () => {
      setDeviceType(
        window.innerWidth <= 768
          ? "mobile"
          : window.innerWidth > 768 && window.innerWidth <= 992
            ? "tablet"
            : "laptop",
      ); // Adjust the width breakpoint as needed
    };

    // Initial check
    updateDeviceType();

    // Listen for window resize events
    window.addEventListener("resize", updateDeviceType);

    // Cleanup listener on unmount
    return () => window.removeEventListener("resize", updateDeviceType);
  }, []);

  // Reset entry page when theme changes to midwestDental
  useEffect(() => {
    if (theme === "midwestDental") {
      setShowEntryPage(true);
      setShowDisclaimerScreen(false);
      setMidwestNavigationStack(["entry"]);
    }
  }, [theme]);

  // Google Tag Manager for specific journey
  useEffect(() => {
    const alternaJourneysForGTM = [
      "68a293fde329f8c3d0966c48",
      "68a57258196850313598330f",
      "69bb7c931700d6f3f3e8e2ca",
      "69ba0b0296ce8774d6e094a9"
    ];
    if (alternaJourneysForGTM.includes(journeyId)) {
      // Add GTM script to head
      const gtmScript = document.createElement("script");
      gtmScript.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','GTM-M64HWP2P');`;

      // Insert at the beginning of head
      const headElement = document.head;
      if (headElement.firstChild) {
        headElement.insertBefore(gtmScript, headElement.firstChild);
      } else {
        headElement.appendChild(gtmScript);
      }

      // Add GTM noscript to body
      const gtmNoscript = document.createElement("noscript");
      const iframe = document.createElement("iframe");
      iframe.src = "https://www.googletagmanager.com/ns.html?id=GTM-M64HWP2P";
      iframe.height = "0";
      iframe.width = "0";
      iframe.style.display = "none";
      iframe.style.visibility = "hidden";
      gtmNoscript.appendChild(iframe);

      // Insert at the beginning of body
      const bodyElement = document.body;
      if (bodyElement.firstChild) {
        bodyElement.insertBefore(gtmNoscript, bodyElement.firstChild);
      } else {
        bodyElement.appendChild(gtmNoscript);
      }

      // Cleanup function to remove scripts when component unmounts or journeyId changes
      return () => {
        if (gtmScript.parentNode) {
          gtmScript.parentNode.removeChild(gtmScript);
        }
        if (gtmNoscript.parentNode) {
          gtmNoscript.parentNode.removeChild(gtmNoscript);
        }
      };
    }
  }, [journeyId]);

  function findSteps(schema) {
    let stepsArray = [];
    for (let i = 0; i < schema?.screens?.length; i++) {
      if (schema.screens[i].label) stepsArray.push(schema.screens[i].label);
    }
    return stepsArray;
  }

  const convertTo12HourFormat = (time24) => {
    if (!time24) return "";
    const [hours, minutes] = time24.split(":");
    const hour24 = parseInt(hours, 10);
    const hour12 = hour24 === 0 ? 12 : hour24 > 12 ? hour24 - 12 : hour24;
    const period = hour24 >= 12 ? "PM" : "AM";
    return `${hour12}:${minutes} ${period}`;
  };
  // Format date for display
  const formatAppointmentDate = (dateString) => {
    const [month, day, year] = dateString.split("/");
    const date = new Date(year, month - 1, day);
    const options = {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric",
    };
    return date.toLocaleDateString("en-US", options);
  };

  // Midwest Dental specific handlers
  const checkMidwestDentalTriggerQuestions = (dataToCheck) => {
    const midwestDentalFormIds = [
      "69be8e7588dae1609a369818",
      "69c1206088dae1609a369ef4",
      "69c121e288dae1609a369f4a",
      "69c1233288dae1609a369f89",
      "69c293e8bcfde05011b67214",
      "69c293d4bcfde05011b67206",
      "69c293f6bcfde05011b6721b",
    ];
    const formId = activeComponent?.formId;

    if (!midwestDentalFormIds.includes(formId)) {
      return { shouldShowDisclaimer: false };
    }

    let screens = dataToCheck?.journey_schema?.screens;

    for (let i = 0; i < screens?.length; i++) {
      if (screens[i]?.id === activeScreenID) {
        let screenPages = screens[i]?.screenPages;
        for (let j = 0; j < screenPages?.length; j++) {
          if (screenPages[j]?.id === activeScreenPageID) {
            const formPages =
              screenPages[j]?.components?.form?.form_schema?.formData;

            if (formPages) {
              const questionsToCheckForNo = [
                "q1HaveYouCompletedAnOvernightSleepStudy",
                "qDoYouHaveAtLeast6StableTeethRemainingOnYourLowerArch",
              ];
              const questionsToCheckForYes = [
                "q7AreYouCurrentlyUndergoingOrthodonticTreatmentBracesClearAlignersRetainersEtc",
                "q5DoYouHaveAnyPlannedOrRecommendedDentalWorkAreYouAwareOfAnyDentalWorkYouMayNeedOrPlanToHaveDoneInTheNext5Years",
              ];

              for (let formPage of formPages) {
                const components = formPage?.content?.components;
                if (!components) continue;
                for (let component of components) {
                  if (questionsToCheckForNo.includes(component.key)) {
                    if (
                      component.answer?.value === "no" ||
                      component.answer?.value === "No"
                    ) {
                      return {
                        shouldShowDisclaimer: true,
                        disclaimerMessage: getDisclaimerMessage(
                          component.key,
                          "no",
                        ),
                      };
                    }
                  }
                  if (questionsToCheckForYes.includes(component.key)) {
                    if (
                      component.answer?.value === "yes" ||
                      component.answer?.value === "Yes"
                    ) {
                      return {
                        shouldShowDisclaimer: true,
                        disclaimerMessage: getDisclaimerMessage(
                          component.key,
                          "yes",
                        ),
                      };
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    return { shouldShowDisclaimer: false };
  };

  const getDisclaimerMessage = (questionKey, answer) => {
    const messages = {
      q1HaveYouCompletedAnOvernightSleepStudy: {
        subtitle:
          "A completed overnight sleep study is required before scheduling an oral appliance consultation.",
        message:
          "Please speak with your primary care provider about a referral, or call us directly, we're happy to help.",
        contactPhone: "(312) 676-9892",
      },
      qDoYouHaveAtLeast6StableTeethRemainingOnYourLowerArch: {
        subtitle:
          "Planned or upcoming dental work can directly affect the fit and longevity of an oral appliance.",
        message:
          "Before scheduling, we'd like to talk through your specific dental plan to make sure the timing is right for you and that your investment is protected. Please call our office and one of our team members will be happy to help.",
        contactPhone: "(312) 676-9892",
      },
      q7AreYouCurrentlyUndergoingOrthodonticTreatmentBracesClearAlignersRetainersEtc:
        {
          subtitle:
            "Patients currently undergoing orthodontic treatment, including braces, clear aligners, or active retainers are not eligible to begin oral appliance therapy until treatment is complete.",
          message:
            "Please call our office and a member of our team will be happy to note your information and reach out when the timing is right for you.",
          contactPhone: "(312) 676-9892",
        },
      q5DoYouHaveAnyPlannedOrRecommendedDentalWorkAreYouAwareOfAnyDentalWorkYouMayNeedOrPlanToHaveDoneInTheNext5Years:
        {
          subtitle:
            "Planned or upcoming dental work can directly affect the fit and longevity of an oral appliance.",
          message:
            "Before scheduling, we'd like to talk through your specific dental plan to make sure the timing is right for you and that your investment is protected. Please call our office and one of our team members will be happy to help.",
          contactPhone: "(312) 676-9892",
        },
    };
    return (
      messages[questionKey] || {
        subtitle: "",
        message:
          "Based on your response, please contact us for further assistance.",
        contactPhone: "(312) 676-9892",
      }
    );
  };

  const handleMidwestDentalNext = (updatedJourneyData) => {
    // Check if updatedJourneyData is an event object
    const isEventObject =
      updatedJourneyData &&
      (updatedJourneyData.nativeEvent !== undefined ||
        updatedJourneyData.target !== undefined ||
        (updatedJourneyData.type &&
          typeof updatedJourneyData.preventDefault === "function"));

    // Use journeyData if updatedJourneyData is an event or undefined
    let journeyDataToCheck =
      isEventObject || !updatedJourneyData ? journeyData : updatedJourneyData;

    // Always check for triggers - simple and straightforward
    const triggerCheck = checkMidwestDentalTriggerQuestions(journeyDataToCheck);

    if (triggerCheck.shouldShowDisclaimer) {
      // Show disclaimer screen
      setDisclaimerConfig(triggerCheck.disclaimerMessage);
      setShowDisclaimerScreen(true);
      setMidwestNavigationStack([...midwestNavigationStack, "disclaimer"]);
      return;
    }

    // Check if this is the last screen's last page — show thank you instead of submitting
    const screens = journeyDataToCheck?.journey_schema?.screens;
    if (screens) {
      for (let i = 0; i < screens.length; i++) {
        if (screens[i]?.id === activeScreenID) {
          const screenPages = screens[i]?.screenPages;
          for (let j = 0; j < screenPages?.length; j++) {
            if (screenPages[j]?.id === activeScreenPageID) {
              if (j + 1 === screenPages.length && i + 1 === screens.length) {
                setShowMidwestThankYou(true);
                return;
              }
            }
          }
        }
      }
    }

    // If no trigger, proceed with normal next
    handleNext(updatedJourneyData);
  };

  const handleMidwestDentalBack = () => {
    // If currently showing disclaimer, go back to form
    if (showDisclaimerScreen) {
      handleDisclaimerGoBack();
      return;
    }

    // If at the first form page, check if we should go back to entry
    const isFirstPage =
      activeScreenID === journeySchema?.screens?.[0]?.id &&
      activeScreenPageID === journeySchema?.screens?.[0]?.screenPages?.[0]?.id;

    if (isFirstPage) {
      // Go back to entry page
      setShowEntryPage(true);
      const newStack = midwestNavigationStack.slice(0, -1); // Remove 'form' from stack
      setMidwestNavigationStack(newStack);
    } else {
      // Normal form navigation - go to previous form page
      handleBack();
    }
  };

  const handleMidwestEntryStart = () => {
    setShowEntryPage(false);
    setMidwestNavigationStack([...midwestNavigationStack, "form"]);
    // Reset activeFormPage to the first page to avoid jumping to the last page
    const firstScreen = journeySchema?.screens?.[0];
    const firstScreenPage = firstScreen?.screenPages?.[0];
    if (firstScreenPage?.components?.form?.form_schema?.formData?.[0]) {
      setActiveFormPage(
        firstScreenPage.components.form.form_schema.formData[0],
      );
    }
  };

  const handleDisclaimerGoBack = () => {
    setShowDisclaimerScreen(false);
    // Remove disclaimer from stack when going back
    const newStack = midwestNavigationStack.filter(
      (page) => page !== "disclaimer",
    );
    setMidwestNavigationStack(newStack);
    // User's answers are preserved, they can change their response and navigate
  };

  const handleThankYouGoBack = () => {
    // Set activeFormPage to the last form page of the last screenPage so
    // FormRenderer remounts on the correct page (not page 1).
    const screens = journeyData?.journey_schema?.screens;
    if (screens) {
      for (let i = 0; i < screens.length; i++) {
        if (screens[i]?.id === activeScreenID) {
          const screenPages = screens[i]?.screenPages;
          for (let j = 0; j < screenPages?.length; j++) {
            if (screenPages[j]?.id === activeScreenPageID) {
              const formData =
                screenPages[j]?.components?.form?.form_schema?.formData;
              if (formData && formData.length > 0) {
                setActiveFormPage(formData[formData.length - 1]);
              }
            }
          }
        }
      }
    }
    setShowMidwestThankYou(false);
  };

  function handleNext(updatedJourneyData) {
    // Check if updatedJourneyData is an event object (from onClick)
    // Event objects have properties like 'nativeEvent', 'target', 'type'
    const isEventObject =
      updatedJourneyData &&
      (updatedJourneyData.nativeEvent !== undefined ||
        updatedJourneyData.target !== undefined ||
        (updatedJourneyData.type &&
          typeof updatedJourneyData.preventDefault === "function"));

    let nextValid = true;
    // Use journeyData if updatedJourneyData is an event or undefined
    let journeyDataUpdated =
      isEventObject || !updatedJourneyData ? journeyData : updatedJourneyData;
    let screens = journeyDataUpdated?.journey_schema?.screens;
    let id = journeyDataUpdated?._id;
    const alternaDentalFormIds = [
      "68a8558c19685031359834bd",
      "68a853c5e329f8c3d09678d4",
      "69131ac6a89f26e6a326389c",
    ];
    const formId = activeComponent?.formId;
    const isAlternaDentalForm = alternaDentalFormIds.includes(formId);
    if (isAlternaDentalForm) nextValid = false;

    if (isAlternaDentalForm) {
      let screens = journeyDataUpdated?.journey_schema?.screens;
      for (let i = 0; i < screens?.length; i++) {
        if (screens[i]?.id === activeScreenID) {
          let screenPages = screens[i]?.screenPages;
          for (let j = 0; j < screenPages?.length; j++) {
            if (screenPages[j]?.id === activeScreenPageID) {
              const components =
                screenPages[j]?.components?.form?.form_schema?.formData?.[0]
                  ?.content?.components;

              if (components) {
                const questionsToCheck = [
                  "doYouHaveAnyChippedOrBrokenTeethThatNeedToBeRepairedOrYouPlanToFix",
                  "doYouWearAnyRemovableDenturesOrPartials",
                  "hasADentistEverToldYouThatYouHaveGumDisease",
                  "doYouHaveAnyMajorDentalWorkPlannedExampleCrownsExtractionsEctThisCouldChangeTheBiteAndImpactTheScansWeTake",
                ];

                let hasYesAnswer = false;

                for (let component of components) {
                  if (questionsToCheck.includes(component.key)) {
                    if (
                      component.answer?.value === "yes" ||
                      component.answer?.value === "Yes"
                    ) {
                      hasYesAnswer = true;
                      // setThankYouMessage(
                      //   "One of our sleep specialists will give you a call to review this in more detail. We want to make sure you get the safest and most effective treatment, and if OAT isn’t the perfect fit, we can also discuss other therapy options."
                      // );
                      break;
                    }
                  }
                }

                // Use the result
                if (hasYesAnswer) {
                  submitFinalJourney(journeyDataUpdated);
                } else {
                  setThankYouMessage(
                    `Your appointment is confirmed. If you have any questions, please call us at 513-401-9012 or text us at 513-998-7474. We look forward to seeing you soon!`,
                  );
                  nextValid = true;
                }
              }
            }
          }
        }
      }
    }

    if (nextValid) {
      for (let i = 0; i < screens?.length; i++) {
        if (screens[i]?.id === activeScreenID) {
          let screenPages = screens[i]?.screenPages;
          for (let j = 0; j < screenPages?.length; j++) {
            if (screenPages[j]?.id === activeScreenPageID) {
              if (j + 1 === screenPages?.length) {
                if (i + 1 !== screens?.length) {
                  setActiveSteps(i + 1);
                  setActiveScreenID(screens[i + 1]?.id);
                  setActiveScreenPageID(screens[i + 1]?.screenPages[0]?.id);
                  setActiveComponent(
                    screens[i + 1]?.screenPages[0]?.components,
                  );
                  setActiveFormPage(
                    screens[i + 1]?.screenPages[0]?.components?.form
                      ?.form_schema?.formData[0],
                  );
                } else {
                  submitFinalJourney(journeyDataUpdated);
                }
              } else {
                setActiveScreenPageID(screenPages[j + 1]?.id);
                setActiveComponent(screenPages[j + 1]?.components);
                setActiveFormPage(
                  screenPages[j + 1]?.components?.form?.form_schema
                    ?.formData[0],
                );
              }
            }
          }
        }
      }
    }
  }

  function handleBack() {
    let screens = journeyData?.journey_schema?.screens;
    let id = journeyData?._id;
    for (let i = 0; i < screens?.length; i++) {
      if (screens[i]?.id === activeScreenID) {
        let screenPages = screens[i]?.screenPages;
        for (let j = 0; j < screenPages?.length; j++) {
          if (screenPages[j]?.id === activeScreenPageID) {
            if (j === 0) {
              if (i > 0) {
                setActiveSteps(i - 1);
                setActiveScreenID(screens[i - 1]?.id);
                setActiveScreenPageID(
                  screens[i - 1]?.screenPages[
                    screens[i - 1]?.screenPages?.length - 1
                  ]?.id,
                );
                setActiveComponent(
                  screens[i - 1]?.screenPages[
                    screens[i - 1]?.screenPages?.length - 1
                  ]?.components,
                );
                let formId =
                  screens[i - 1]?.screenPages[
                    screens[i - 1]?.screenPages?.length - 1
                  ]?.components?.formId;

                let formPage =
                  screens[i - 1]?.screenPages[
                    screens[i - 1]?.screenPages?.length - 1
                  ]?.components?.form?.form_schema?.formData;

                if (
                  formId === "66ec5b455b3a1419fb717b99" ||
                  formId === "68525a6f4ef9cc55588fb84b" ||
                  formId === "6819ad9dc4f18e73b7d06d38"
                ) {
                  if (
                    answerData?.iDontWantToAddMyCardOnFile &&
                    answerData.iDontWantToAddMyCardOnFile?.value == true
                  ) {
                    setActiveFormPage(
                      screens[i - 1]?.screenPages[
                        screens[i - 1]?.screenPages?.length - 1
                      ]?.components?.form?.form_schema?.formData[0],
                    );
                  }
                } else {
                  setActiveFormPage(
                    screens[i - 1]?.screenPages[
                      screens[i - 1]?.screenPages?.length - 1
                    ]?.components?.form?.form_schema?.formData[
                      formPage?.length - 1
                    ],
                  );
                }
              }
            } else {
              setActiveScreenPageID(screenPages[j - 1]?.id);
              setActiveComponent(screenPages[j - 1]?.components);
              let formPage =
                screenPages[j - 1]?.components?.form?.form_schema?.formData;
              setActiveFormPage(
                screenPages[j - 1]?.components?.form?.form_schema?.formData[
                  formPage?.length - 1
                ],
              );
            }
          }
        }
      }
    }
  }
  const setAnswerForWidget = () => {
    let updatedJourneyData = JSON.parse(JSON.stringify(journeyData));
    let screens = updatedJourneyData?.journey_schema?.screens;

    for (let i = 0; i < screens?.length; i++) {
      if (screens[i]?.id === activeScreenID) {
        let screenPages = screens[i]?.screenPages;
        for (let j = 0; j < screenPages?.length; j++) {
          if (
            screenPages[j]?.id === activeScreenPageID &&
            screenPages[j].components?.type === "widget"
          ) {
            screenPages[j].components.answer = {
              status: "payment-successful",
              message: "Your Payment is confirmed",
            };
          }
        }
      }
    }
    setJourneyData(updatedJourneyData);
  };

  const setAnswerForSchedulerWidget = (data) => {
    setAppointmentData(data);
    let updatedJourneyData = JSON.parse(JSON.stringify(journeyData));
    let screens = updatedJourneyData?.journey_schema?.screens;

    for (let i = 0; i < screens?.length; i++) {
      if (screens[i]?.id === activeScreenID) {
        let screenPages = screens[i]?.screenPages;
        for (let j = 0; j < screenPages?.length; j++) {
          if (
            screenPages[j]?.id === activeScreenPageID &&
            screenPages[j].components?.type === "scheduler-widget"
          ) {
            screenPages[j].components.answer = {
              status: "appointment-successful",
              message: "You Appointment is confirmed",
              data,
            };
          }
        }
      }
    }
    setJourneyData(updatedJourneyData);
  };

  // const submitFinalJourney = async (journeyData) => {
  //   if (cancelAppointmentJourneys?.includes(journeyId)) {
  //     const API_URL = process.env.REACT_APP_SCHEDULER_URL;
  //     const CANCEL_API_URL = `${API_URL}/api/v1/appointments/cancel/${hashId}`;
  //     try {
  //       const response = await axios.put(CANCEL_API_URL, {
  //         reasonId: 41, //fixed
  //         reason: answerData?.reasonForAppointmentCancellation?.value, //input
  //         hash: hashId, //params.id
  //       });
  //       navigate("/thank-you");
  //       return response;
  //     } catch (e) {
  //       console.log(e);
  //       // Display any error message from the response
  //       if (e.response?.data?.HBx) {
  //         // Show modal with countdown
  //         setErrorMessage(e.response.data.HBx?.message);
  //         setShowErrorModal(true);

  //         // Start countdown and redirect after 5 seconds
  //         let countdown = 5;
  //         setCountdownValue(countdown);

  //         const countdownInterval = setInterval(() => {
  //           countdown -= 1;
  //           setCountdownValue(countdown);

  //           if (countdown <= 0) {
  //             clearInterval(countdownInterval);
  //             setShowErrorModal(false);
  //             navigate("/thank-you");
  //           }
  //         }, 1000);

  //         return { error: true };
  //       }
  //       return { error: true };
  //     }
  //   } else {
  //     console.log("FINAL JOURNEY SUBMISSION", journeyData);
  //     setIsLoading(true);
  //     setLoaderMessage("Submitting your data...");

  //     if (callAthenaApisJourneyIds.includes(journeyId)) {
  //       if (hashId && hashId !== "undefined") {
  //         const API_URL = process.env.REACT_APP_SCHEDULER_URL;
  //         const completeCheckinURL = `${API_URL}/api/v1/checkin/${hashId}/complete`;
  //         callAthenaPostApi(completeCheckinURL);
  //       }
  //     }

  //     console.log("finalQnaTriggerBody", journeyData);

  //     // let workflowStatus = await triggerAttachedWorkflows();
  //     let workflowStatus = await submitJourneyFortriggers(
  //       journeyData?.journey_schema,
  //       journeyData?._id
  //     );
  //     if (journeyInstanceId) {
  //       const response = await updateJourneyDataForInstanceId(
  //         journeyInstanceId,
  //         {
  //           journey_schema: journeyData?.journey_schema,
  //           status: "COMPLETED",
  //         }
  //       );
  //     }

  //     // if (journeyContext && journeyContext?.workflowContext) {
  //     //   const payload = {
  //     //     stepId: journeyContext.workflowContext?.stepId,
  //     //     status: "SUCCESS",
  //     //     result: { ...qnABodyForTriggers } || {}, // The form data becomes the result object
  //     //     context: journeyContext.workflowContext?.context || {}, // Include the context if available
  //     //   };
  //     //   const workflowInstanceId = journeyContext?.workflowInstanceId;
  //     //   const apiUrl = `${process.env.REACT_APP_WORKFLOW_BACKEND_URL}/api/v1/workflow-instances/${workflowInstanceId}/resume`;
  //     //   const response = await axios.post(apiUrl, payload);
  //     // }
  //     navigate("/thank-you");
  //     setIsLoading(false);
  //     setLoaderMessage("");
  //     // if (workflowStatus) {
  //     //   navigate("/thank-you");
  //     // }
  //   }
  // };

  const submitFinalJourney = async (journeyData, moveToThankYouPage = true) => {
    const addSubmissionDate = (data) => {
      const date = new Date();
      const submissionDate = `${
        date.getMonth() + 1
      }/${date.getDate()}/${date.getFullYear()}`; // MM/DD/YYYY format

      // Clone the journey data to avoid mutating the original
      const updatedData = JSON.parse(JSON.stringify(data));

      // Create the submission date field object
      const submissionDateField = {
        label: "Journey Submission Date",
        type: "textfield",
        key: "journeySubmissionDate",
        input: true,
        disabled: true,
        defaultValue: submissionDate,
        hidden: true,
        persistent: true,
        tableView: false,
        id: `submission-date-${Date.now()}`,
        answer: {
          value: submissionDate,
        },
      };

      if (
        updatedData?.journey_schema?.screens &&
        updatedData.journey_schema.screens.length > 0
      ) {
        const lastScreenIndex = updatedData.journey_schema.screens.length - 1;
        const lastScreen = updatedData.journey_schema.screens[lastScreenIndex];

        if (lastScreen.screenPages && lastScreen.screenPages.length > 0) {
          lastScreen.screenPages.forEach((page) => {
            if (page.components?.form?.form_schema?.formData) {
              const lastFormIndex =
                page.components.form.form_schema.formData.length - 1;
              if (lastFormIndex >= 0) {
                const lastFormPage =
                  page.components.form.form_schema.formData[lastFormIndex];

                if (lastFormPage.content?.components) {
                  lastFormPage.content.components.push(submissionDateField);
                }
              }
            }
          });
        }
      }

      return updatedData;
    };
    const journeyDataWithDate = addSubmissionDate(journeyData);

    if (cancelAppointmentJourneys?.includes(journeyId)) {
      const API_URL = process.env.REACT_APP_SCHEDULER_URL;
      const CANCEL_API_URL = `${API_URL}/api/v1/appointments/cancel/${hashId}`;
      try {
        const response = await axios.put(CANCEL_API_URL, {
          reasonId: 41,
          reason: answerData?.reasonForAppointmentCancellation?.value,
          hash: hashId,
        });
        if (moveToThankYouPage) {
          navigate("/thank-you");
        }
        return response;
      } catch (e) {
        console.log(e);
        if (e.response?.data?.HBx) {
          setErrorMessage(e.response.data.HBx?.message);
          setShowErrorModal(true);

          let countdown = 5;
          setCountdownValue(countdown);

          const countdownInterval = setInterval(() => {
            countdown -= 1;
            setCountdownValue(countdown);

            if (countdown <= 0) {
              clearInterval(countdownInterval);
              setShowErrorModal(false);
              if (moveToThankYouPage) {
                navigate("/thank-you");
              }
            }
          }, 1000);

          return { error: true };
        }
        return { error: true };
      }
    } else {
      setIsLoading(true);
      setLoaderMessage("Submitting your data...");

      if (callAthenaApisJourneyIds.includes(journeyId)) {
        if (hashId && hashId !== "undefined") {
          const API_URL = process.env.REACT_APP_SCHEDULER_URL;
          const completeCheckinURL = `${API_URL}/api/v1/checkin/${hashId}/complete`;
          callAthenaPostApi(completeCheckinURL);
        }
      }

      if (!journeyInstanceId) {
        const queryParamsToSubmit = journeyQueryParams.reduce(
          (acc, paramName) => {
            if (queryParamsObject.hasOwnProperty(paramName)) {
              acc[paramName] = queryParamsObject[paramName];
            }
            return acc;
          },
          {},
        );
        let workflowStatus = await submitJourneyFortriggers(
          {
            ...journeyDataWithDate?.journey_schema,
            queryParams: queryParamsToSubmit,
          },
          journeyDataWithDate?._id,
        );
      } else {
        const queryParamsToSubmit = journeyQueryParams.reduce(
          (acc, paramName) => {
            if (queryParamsObject.hasOwnProperty(paramName)) {
              acc[paramName] = queryParamsObject[paramName];
            }
            return acc;
          },
          {},
        );
        await submitJourneyFortriggers(
          {
            ...journeyDataWithDate?.journey_schema,
            queryParams: queryParamsToSubmit,
          },
          journeyDataWithDate?.journey,
        );
      }

      if (journeyInstanceId) {
        const response = await updateJourneyDataForInstanceId(
          journeyInstanceId,
          {
            journey_schema: journeyDataWithDate?.journey_schema,
            status: "COMPLETED",
          },
        );
      }
      if (theme !== "midwestDental") {
        setIsLoading(false);
        setLoaderMessage("");
      } else {
        setTimeout(() => {
          setIsLoading(false);
          setLoaderMessage("");
        }, 3000);
      }
      if (theme === "alternaSleep") {
        setShowAlternaSleepPopup(true);
      } else if (theme === "midwestDental") {
        if (moveToThankYouPage) {
          setShowMidwestThankYou(true);
        }
      } else {
        if (moveToThankYouPage) {
          navigate("/thank-you");
        }
      }
    }
  };

  const AlternaSleepPopup = () => {
    if (!showAlternaSleepPopup) return null;

    return (
      <div
        className="fixed inset-0 flex items-center justify-center z-50"
        style={{ backgroundColor: "#183e9f" }}
      >
        {/* Popup Content */}
        <div
          className="bg-white rounded-lg p-8 mx-4 text-center shadow-2xl"
          style={{ width: "756px", maxWidth: "90vw" }}
        >
          {/* Thank You Icon */}
          <div className="mb-6 flex justify-center">
            <img
              src="https://hbx-assets.s3.us-east-1.amazonaws.com/journeys/Alterna/Thankyou-iconV2.png"
              alt="Thank You"
              className="w-32 h-32 object-contain"
              onError={(e) => {
                // Fallback if image fails to load
                e.target.style.display = "none";
                e.target.nextSibling.style.display = "flex";
              }}
            />
            {/* Fallback icon if image fails */}
            <div
              className="w-24 h-24 rounded-full flex items-center justify-center hidden"
              style={{ backgroundColor: "#10b981" }}
            >
              <svg
                className="w-12 h-12 text-white"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M5 13l4 4L19 7"
                ></path>
              </svg>
            </div>
          </div>

          {/* Thank You Text */}
          <h2
            className="font-semibold text-center mb-4"
            style={{ fontSize: "50px", lineHeight: "50px" }}
          >
            Thank You!
          </h2>

          <p
            className="text-lg leading-relaxed mb-0"
            style={{ color: "#2c3344", opacity: 0.66 }}
          >
            Your submission has been received. One of our Alterna Sleep experts
            will be in touch shortly to discuss next steps.
          </p>
        </div>
      </div>
    );
  };
  const getTriggerUrl = async (triggerId) => {
    const API_URL = process.env.REACT_APP_WORKFLOW_BACKEND_URL;
    // const triggerAPIUrl = `${API_URL}/api/v1/webhooks/${triggerId}`;
    const triggerAPIUrl = `${API_URL}/api/v1/webhooks/open/journeySubmission/${triggerId}`;
    const response = await axios.get(triggerAPIUrl);
    if (response && response.data) {
      return response.data.url;
    }
    return null;
  };

  const triggerAttachedWorkflows = async () => {
    let workflowInstances = [];
    if (journeyTriggers.length > 0) {
      let triggerBody = {
        journeyData: qnABodyForTriggers,
        context: {},
        appointmentHash: hashId || null,
      };

      if (journeyContext) {
        triggerBody.context = {
          ...triggerBody.context,
          ...journeyContext,
        };
      }

      // Trigger all workflows
      for (let i = 0; i < journeyTriggers.length; i++) {
        let trigger = journeyTriggers[i];
        let triggerUrl = await getTriggerUrl(trigger);

        if (triggerUrl) {
          try {
            let response = await axios.post(triggerUrl, triggerBody);
            if (response?.data?.workflowInstances) {
              workflowInstances = [
                ...workflowInstances,
                ...response.data.workflowInstances,
              ];
            }
          } catch (error) {
            console.error("Error triggering workflow:", error);
            return false; // Return false if any trigger fails
          }
        }
      }
    }
    // Otherwise, poll for completion status of all workflow instances
    return await checkAllWorkflowsCompletion(workflowInstances);
  };

  const checkAllWorkflowsCompletion = async (instanceIds) => {
    if (!instanceIds.length) return true;

    const MAX_ATTEMPTS = 1; // Maximum 3 minutes (60 * 3 seconds)
    let attempts = 0;

    // Keep checking until we reach max attempts
    while (attempts < MAX_ATTEMPTS) {
      let allCompleted = true;
      let anyFailed = false;

      // Check status of each workflow instance
      for (let instanceId of instanceIds) {
        const status = await checkWorkflowCompletion(instanceId);
        if (status === "FAILED") {
          anyFailed = true;
          break; // Exit early if any workflow fails
        } else if (status !== "SUCCESS") {
          allCompleted = false; // Not all are completed yet
        }
      }

      // If any failed, return false
      if (anyFailed) {
        return false;
      }

      // If all completed successfully, return true
      if (allCompleted) {
        return true;
      }

      // Wait for 3 seconds before next check
      await new Promise((resolve) => setTimeout(resolve, 3000));
      attempts++;
    }

    // If we reached max attempts without all completing successfully,
    // we consider it a timeout failure
    console.error("Workflow completion check timed out after 1 minutes");
    return false;
  };

  const checkWorkflowCompletion = async (instanceId) => {
    const API_URL = process.env.REACT_APP_WORKFLOW_BACKEND_URL;
    const workflowAPIUrl = `${API_URL}/api/v1/workflow-instances/${instanceId}`;

    try {
      const response = await axios.get(workflowAPIUrl);
      if (response?.data) {
        return response.data.status; // Returns one of: PENDING, FAILED, RUNNING, PAUSED, SUCCESS
      }
    } catch (error) {
      console.error(`Error checking workflow status for ${instanceId}:`, error);
      return "FAILED"; // Consider API errors as failures
    }

    return "PENDING"; // Default to PENDING if no valid response
  };

  const fetchFormSchema = async (formData) => {
    let res;
    if (formData?.form) {
      return formData?.form;
    }
    if (formData?.type === "user-form")
      res = await getFormDataForUsers(formData?.formId);
    if (formData?.type === "standard-form")
      res = await getStandardFormData(formData?.formId);
    // change schema to from_schema for standard form from backend and also in form playground where getStandardFormData is called.
    // clean button schemas
    let formKeys = [];
    let form = res?.data?.form;
    // form?.form_schema?.formData?.forEach((formPage) => {
    //   formPage.content.components = formPage?.content?.components?.filter(
    //     (item) => {
    //       const isSubmitButton =
    //         item?.key === "submit" &&
    //         item?.type === "button" &&
    //         item?.action === "submit";

    //       // if (item?.type === "selectboxes") {
    //       //   const defaultValues = item?.defaultValue || {};
    //       //   const answerObj = {};
    //       //   Object.entries(defaultValues).forEach(([key, value]) => {
    //       //     if (value || value === "true") {
    //       //       answerObj[key] = value;
    //       //     }
    //       //   });
    //       //   if (Object.keys(answerObj).length > 0) {
    //       //     item.answer = {
    //       //       value: answerObj,
    //       //     };
    //       //   }
    //       // } else {
    //       //   item.answer = {
    //       //     value: item?.defaultValue || "",
    //       //   };
    //       // }

    //       if (!isSubmitButton && item?.key) {
    //         formKeys.push(item.key);
    //       }

    //       return !isSubmitButton;
    //     }
    //   );
    // });
    // console.log("formKeys", formKeys);

    await Promise.all(
      form.form_schema.formData.map(async (formPage) => {
        if (formPage?.content?.components) {
          // Map over components and update if fetchOptionsFromApi is set
          formPage.content.components = (
            await Promise.all(
              formPage.content.components.map(async (item) => {
                if (item?.fetchOptionsFromApi && item?.apiUrl) {
                  // Wait for fetchOptionsFromAPI to resolve and assign it to item.values
                  if (item?.type === "select") {
                    item.data.values = await fetchOptionsFromAPI(
                      item.apiUrl,
                      item?.key,
                    );
                  } else {
                    item.values = await fetchOptionsFromAPI(
                      item.apiUrl,
                      item?.key,
                    );
                  }
                }
                if (item?.createForm && item?.apiUrl) {
                  // Use await to get the array returned by createFormFromApis
                  let { formQuestionsSet } = await createFormFromApis(
                    item.apiUrl,
                  );
                  return formQuestionsSet; // Return the array for later flattening
                }
                return item; // Return single item if no form creation
              }),
            )
          ).flat(); // Flatten any nested arrays in components
        }
      }),
    );

    form.form_schema.formData = form?.form_schema?.formData.filter(
      (formPage) => formPage?.content?.components?.length !== 0,
    );
    return form;
  };

  const fetchOptionsFromAPI = async (apiUrl, key) => {
    const API_URL = process.env.REACT_APP_SCHEDULER_URL;
    const API_COMPLETE_URL = apiUrl
      .replace("${API_URL}", API_URL)
      .replace("${hashIdFromQP}", hashId);
    const res = await callAthenaGetApi(API_COMPLETE_URL);
    let formattedValue = null;
    if (
      [
        "genderIdentity",
        "insuranceCompanyName",
        "demographicsEthnicity",
        "demographicsPreferredLanguage",
        "demographicsRace",
        "pleaseEnterYourMedicalConditionSBelow",
      ].includes(key)
    ) {
      formattedValue = optionsFormatter(res?.data?.HBx, key);
    }
    return formattedValue;
  };

  const createFormFromApis = async (apiUrl) => {
    const API_URL = process.env.REACT_APP_SCHEDULER_URL;
    const API_COMPLETE_URL = apiUrl
      .replace("${API_URL}", API_URL)
      .replace("${hashIdFromQP}", hashId);
    const res = await callAthenaGetApi(API_COMPLETE_URL);
    const HBx = res.data?.HBx;
    const formQuestionsSet = [];
    const socialKeys = [];

    HBx?.forEach((template, index) => {
      formQuestionsSet.push({
        html: `<p><span style="font-family:Georgia, serif;"><strong>${template?.templatename}</strong></span></p>`,
        label: template?.templatename,
        customClass: "text-xl text-semi-bold py-1",
        key: template?.templatename,
        type: "content",
        templateid: template?.templateid,
      });
      template?.questions?.forEach((quesObj, idx) => {
        let formattedQuesObj;
        if (quesObj?.inputtype === "DROPDOWN") {
          formattedQuesObj = {
            ...quesObj,
            label: quesObj?.question,
            key: quesObj?.key,
            type: "select",
            data: {
              values: [],
            },
          };

          quesObj?.options?.forEach((option) => {
            const entries = Object.entries(option);
            const [key, value] = entries[0];
            formattedQuesObj.data.values.push({
              label: value,
              value: key,
            });
          });
          socialKeys.push(quesObj?.key);
        }

        if (quesObj?.inputtype === "YESNO") {
          formattedQuesObj = {
            ...quesObj,
            label: quesObj?.question,
            key: quesObj?.key,
            type: "radio",
            values: [
              {
                label: "Yes",
                value: "Y",
                shortcut: "",
              },
              {
                label: "No",
                value: "N",
                shortcut: "",
              },
            ],
          };
          socialKeys.push(quesObj?.key);
          quesObj?.options?.forEach((option) => {
            const entries = Object.entries(option);
            const [key, value] = entries[0];
            formattedQuesObj.data.values.push({
              label: value,
              value: key,
            });
          });
        }

        if (quesObj?.inputtype === "NUMERIC") {
          formattedQuesObj = {
            ...quesObj,
            label: quesObj?.question,
            key: quesObj?.key,
            type: "number",
          };
          socialKeys.push(quesObj?.key);
        }
        if (quesObj?.inputtype === "FREETEXT") {
          formattedQuesObj = {
            ...quesObj,
            label: quesObj?.question,
            key: quesObj?.key,
            type: "textarea",
          };
          socialKeys.push(quesObj?.key);
        }
        if (quesObj?.inputtype === "DATE") {
          formattedQuesObj = {
            ...quesObj,
            label: quesObj?.question,
            key: quesObj?.key,
            type: "datetime",
          };
          socialKeys.push(quesObj?.key);
        }
        // formattedQuesObj && formQuestionsSet.push(formattedQuesObj);
        formQuestionsSet.push(formattedQuesObj);
      });
    });
    setSocialKeys(socialKeys);
    return { formQuestionsSet, socialKeys };
  };

  const optionsFormatter = (data, key) => {
    if (key === "genderIdentity") {
      let updatedData = data?.filter((value) => {
        return !!value;
      });
      return updatedData?.map((value) => {
        return { value: value, label: value };
      });
    }
    if (key === "insuranceCompanyName") {
      let updatedData = data?.filter((item) => {
        return !!item;
      });
      return updatedData?.map((item) => {
        return { ...item, value: item?.insurancePackageId, label: item?.name };
      });
    }
    if (key === "pleaseEnterYourMedicalConditionSBelow") {
      let updatedData = data?.questions?.filter((item) => {
        return !!item;
      });
      return updatedData?.map((item) => {
        return { ...item, value: item?.questionid, label: item?.question };
      });
    }
    if (key === "demographicsRace") {
      return data?.map((langObj) => {
        return {
          value: langObj?.raceid || "not-defined",
          label: langObj?.name,
        };
      });
    }

    if (key === "demographicsPreferredLanguage") {
      return data?.map((langObj) => {
        return {
          value: langObj?.iso6392code || "not-defined",
          label: langObj?.name,
        };
      });
    }

    if (key === "demographicsEthnicity") {
      return data?.map((langObj) => {
        return {
          value: langObj?.ethnicityid || "not-defined",
          label: langObj?.name,
        };
      });
    }
  };

  const getWidgetId = (data) => {
    const screens = data?.journey_schema?.screens || [];
    for (const screen of screens) {
      for (const page of screen?.screenPages || []) {
        const component = page?.components;
        if (component?.type === "scheduler-widget") {
          return component?.widget?.id || null;
        }
      }
    }
    return null; // Return null if no widget ID is found
  };
  const updateJourneySchemaForInstanceID = async (journeyInstanceId) => {
    const response = await getJourneyDataForInstanceId(journeyInstanceId, () =>
      navigate("/404_not_found"),
    );
    if (response?.data?.journeyInstance) {
      let journeyData = JSON.parse(
        JSON.stringify(response?.data?.journeyInstance),
      );
      // Set journey status and determine if it should be readonly
      const status = journeyData?.status;
      setJourneyStatus(status);
      setIsJourneyReadOnly(status === "COMPLETED");
      setJourneyTriggers(journeyData?.triggers);
      setJourneyQueryParams(journeyData?.queryParams || []);
      setJourneyConfigs(journeyData?.journey_schema?.configs || {});
      setJourneyConfigsGlobal(journeyData?.journey_schema?.configs || {});
      setJourneyContext(journeyData?.context);

      const journeyTheme = journeyData?.journey_schema?.journeyTheme;
      journeyTheme && setCSSVariables(journeyTheme);
      journeyData = await updateSchemaWithFormRemovals(
        journeyData,
        journeyData?.journey,
      );

      let schema = await updateSchemaWithFormData(journeyData?.journey_schema);
      if (schema?.theme) {
        setTheme(schema.theme);
        setCSSVariables(themes[schema.theme]);
      }
      // setTheme("theme2");
      //   setCSSVariables(themes["theme2"]);
      let { parentJourney } = schema;
      parentJourney &&
        (await mapParentSchedulerToJourney(schema?.parentJourney));
      let prepopulatedBody = null;

      let schedulerID = getWidgetId(journeyData);
      if (schedulerID && patientId) {
        prepopulatedBody = await prePopulateFieldsForPatientInfo(
          patientId,
          schedulerID,
        );
      }
      if (schedulerID && hash) {
        prepopulatedBody = await prePopulateFieldsForPatientInfoWithHash(
          hash,
          schedulerID,
        );
      }
      if (hashId && hashId !== "undefined") {
        prepopulatedBody =
          await prepopulateFieldsForPatientInfoWithHashID(hashId);
      }

      if (prepopulatedBody) {
        let updatedJourneySchema = JSON.parse(
          JSON.stringify(
            await updateJourneyDataWithPrePopulatedValues(
              schema,
              prepopulatedBody,
            ),
          ),
        );
        journeyData.journey_schema = updatedJourneySchema;
        schema = updatedJourneySchema;
      }

      // Process workflow context data and update schema with answers
      await processWorkflowContextAndUpdateSchema(schema, journeyData);
      setJourneyData(journeyData);
      setJourneySchema(schema);
      setSteps(findSteps(schema));
      setActiveScreenID(schema?.screens[0]?.id);
      setActiveScreenPageID(schema?.screens[0]?.screenPages[0]?.id);
      setActiveComponent(schema?.screens[0]?.screenPages[0]?.components);
      setActiveFormPage(
        schema?.screens[0]?.screenPages[0]?.components?.form?.form_schema
          ?.formData[0],
      );
      setFirstPageFirstFormID(
        schema?.screens[0]?.screenPages[0]?.components?.form?.form_schema
          ?.formData[0]?.id,
      );
      setIsLoading(false);
      setLoaderMessage("");
    }
  };

  // Helper function to format date in US format (MM/DD/YYYY)
  const formatToUSDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    });
  };

  // Helper function to format time in US format (12-hour with AM/PM)
  const formatToUSTime = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    return date.toLocaleTimeString("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  };

  const createDateObject = (
    dateTimeValue,
    field = {
      type: "date", // default to date, can be overridden
    },
  ) => {
    if (!dateTimeValue) return null;
    try {
      let dateObj;
      let isoString;

      if (field.type === "date") {
        // For date only, create date object
        dateObj = new Date(dateTimeValue);
        isoString = dateObj.toISOString();
      } else {
        // For datetime
        dateObj = new Date(dateTimeValue);
        isoString = dateObj.toISOString();
      }

      return {
        date: formatToUSDate(isoString),
        time: field.type === "dateTime" ? formatToUSTime(isoString) : null,
        dateObj: dateObj,
        isoString: isoString,
        timestamp: dateObj.getTime(),
        year: dateObj.getFullYear(),
        month: dateObj.getMonth() + 1,
        day: dateObj.getDate(),
        hour: field.type === "dateTime" ? dateObj.getHours() : null,
        minute: field.type === "dateTime" ? dateObj.getMinutes() : null,
        dayOfWeek: dateObj.toLocaleDateString("en-US", { weekday: "long" }),
        monthName: dateObj.toLocaleDateString("en-US", { month: "long" }),
        formattedDateTime:
          field.type === "dateTime"
            ? dateObj.toLocaleDateString("en-US") +
              " " +
              dateObj.toLocaleTimeString("en-US", { hour12: true })
            : dateObj.toLocaleDateString("en-US"),
        raw: dateTimeValue,
      };
    } catch (error) {
      return null;
    }
  };

  const processWorkflowContextAndUpdateSchema = async (schema, journeyData) => {
    function getEmail(input) {
      // If it's already an array, return the first element
      if (Array.isArray(input)) {
        return input[0];
      }

      // If it's a string (JSON format), parse it
      if (typeof input === "string") {
        try {
          // Parse the JSON string to get the array
          const parsed = JSON.parse(input);

          // If the parsed result is an array, return the first element
          if (Array.isArray(parsed)) {
            return parsed[0];
          }

          // If it's not an array after parsing, return the parsed value
          return parsed;
        } catch (error) {
          return input;
        }
      }

      return "";
    }
    const workflowContext =
      journeyData?.context?.workflowContext?.journeyData || {};

    setWorkflowContext(workflowContext);

    // Initialize data structures
    let updatedAnswerData = {};
    let updatedJourneyAnswers = [];
    let updatedJourneyData = JSON.parse(JSON.stringify(journeyData));

    // Loop through all screens
    for (let i = 0; i < schema?.screens?.length; i++) {
      const screen = schema.screens[i];

      // Loop through all screen pages
      for (let j = 0; j < screen?.screenPages?.length; j++) {
        const screenPage = screen.screenPages[j];
        const form = screenPage?.components?.form?.form_schema?.formData;
        const formId = screenPage?.components?.formId;

        if (form) {
          // Loop through all form pages
          for (let k = 0; k < form.length; k++) {
            const formPage = form[k];
            const components = formPage?.content?.components;

            if (components) {
              // Loop through all form components
              for (let l = 0; l < components.length; l++) {
                const component = components[l];
                const componentKey = component?.key;

                if (componentKey) {
                  let answerValue = null;
                  let shouldUpdateAnswer = false;

                  // Check if answer already exists
                  if (
                    component?.answer &&
                    component.answer?.value &&
                    component.answer.value !== ""
                  ) {
                    // Answer exists, use it
                    answerValue = component.answer.value;
                    if (componentKey === "HBxFirstName") {
                      setHBxFirstName(answerValue);
                    }
                    if (componentKey === "HBxLastName") {
                      setHBxLastName(answerValue);
                    }
                    if (componentKey === "HBxEmail") {
                      setHBxEmail(answerValue);
                    }
                    if (componentKey === "HBxDob") {
                      setHBxDob(answerValue);
                    }
                  } else if (
                    workflowContext[componentKey] !== undefined &&
                    workflowContext[componentKey] !== ""
                  ) {
                    // No answer exists but value is in workflowContext
                    answerValue =
                      componentKey === "HBxEmail"
                        ? getEmail(workflowContext[componentKey])
                        : workflowContext[componentKey];
                    shouldUpdateAnswer = true;
                  } else if (component?.defaultValue !== undefined) {
                    if (component?.type === "selectboxes") {
                      const defaultValues = component?.defaultValue || {};
                      const answerObj = {};
                      Object.entries(defaultValues).forEach(([key, value]) => {
                        if (value || value === "true") {
                          answerObj[key] = value;
                        }
                      });
                      if (Object.keys(answerObj).length > 0) {
                        answerValue = answerObj;
                        shouldUpdateAnswer = true;
                      }
                    } else if (component?.type === "dob") {
                      answerValue = createDateObject(component?.defaultValue, {
                        type: "date",
                      });
                      shouldUpdateAnswer = true;
                    } else {
                      answerValue = component?.defaultValue || "";
                      shouldUpdateAnswer = true;
                    }
                  }

                  // Need to recheck above code !

                  // if (component?.answer && component.answer?.value) {
                  //   // Answer exists, use it
                  //   answerValue = component.answer.value;
                  //   if (componentKey === "HBxFirstName") {
                  //     setHBxFirstName(answerValue);
                  //   }
                  //   if (componentKey === "HBxLastName") {
                  //     setHBxLastName(answerValue);
                  //   }
                  //   if (componentKey === "HBxEmail") {
                  //     setHBxEmail(answerValue);
                  //   }
                  //   if (componentKey === "HBxDob") {
                  //     setHBxDob(answerValue);
                  //   }
                  // }
                  // if (workflowContext[componentKey] !== undefined) {
                  //   // No answer exists but value is in workflowContext
                  //   answerValue = workflowContext[componentKey];
                  //   shouldUpdateAnswer = true;
                  // }

                  if (answerValue !== null) {
                    const answer = { value: answerValue };
                    const question = {
                      label: component.label || componentKey,
                      key: componentKey,
                      type: component.type || "textfield",
                    };

                    // Update component answer if needed
                    if (shouldUpdateAnswer) {
                      component.answer = answer;
                      component.formValidation = true;
                      if (componentKey === "HBxFirstName") {
                        setHBxFirstName(answer?.value);
                      }
                      if (componentKey === "HBxLastName") {
                        setHBxLastName(answer?.value);
                      }
                      if (componentKey === "HBxEmail") {
                        setHBxEmail(answer?.value);
                      }
                      if (componentKey === "HBxDob") {
                        setHBxDob(answer?.value);
                      }
                    }

                    // Update updatedAnswerData
                    updatedAnswerData[componentKey] = answer;

                    // Update journey answers
                    let journeyIndex = updatedJourneyAnswers.findIndex(
                      (item) => item.key === componentKey,
                    );
                    if (journeyIndex === -1) {
                      updatedJourneyAnswers.push({
                        key: componentKey,
                        question: component.label || componentKey,
                        answer: answer,
                      });
                    } else {
                      updatedJourneyAnswers[journeyIndex].answer = answer;
                    }

                    // Update journey data structure in updatedJourneyData
                    for (
                      let x = 0;
                      x < updatedJourneyData?.journey_schema?.screens?.length;
                      x++
                    ) {
                      const journeyScreen =
                        updatedJourneyData.journey_schema.screens[x];
                      for (
                        let y = 0;
                        y < journeyScreen?.screenPages?.length;
                        y++
                      ) {
                        const journeyScreenPage = journeyScreen.screenPages[y];
                        const journeyForm =
                          journeyScreenPage?.components?.form?.form_schema
                            ?.formData;

                        if (journeyForm) {
                          for (let z = 0; z < journeyForm.length; z++) {
                            const journeyFormPage = journeyForm[z];
                            journeyFormPage?.content?.components?.forEach(
                              (ques) => {
                                if (ques?.key === componentKey) {
                                  ques.answer = answer;
                                  ques.formValidation = true;
                                }
                              },
                            );
                          }
                        }
                      }
                    }

                    if (component.type !== "file") {
                      // Add to trigger body
                      addAnswerToTriggerBody(
                        formId,
                        formPage?.id,
                        question,
                        answer,
                      );
                    }
                  }
                }
              }
            }
          }
        }
      }
    }

    // Update all states with the processed data
    setAnswerData(updatedAnswerData);
    setCompleteJourneyAnswers(updatedJourneyAnswers);
    setJourneyData(updatedJourneyData);
  };

  // Function to add an answer to a specific form, form page, and question
  function addAnswerToTriggerBody(formId, activeFormPageId, question, answer) {
    const questionKey = question?.key;
    const questionLabel = question?.label;
    setQnABodyForTriggers((prevState) => {
      // Create a copy of the previous state
      const newState = { ...prevState };

      // If the form doesn't exist yet, create it
      if (!newState[formId]) {
        newState[formId] = {};
      }

      // If the form page doesn't exist yet, create it
      if (!newState[formId][activeFormPageId]) {
        newState[formId][activeFormPageId] = {};
      }
      // Determine the answer value, handling boolean values properly
      let answerValue;
      if (answer?.label !== undefined) {
        answerValue = answer.label;
      } else if (answer?.value !== undefined) {
        answerValue = answer.value; // This now properly handles boolean values
      }

      // Add the question-answer pair to the specific form page
      newState[formId][activeFormPageId][questionKey] = {
        question: questionLabel,
        answer: answerValue,
      };
      if (question?.type === "file" && answer?.value) {
        newState[formId][activeFormPageId][questionKey].answer =
          question?.fileId;
      }
      if (answer?.time) {
        newState[formId][activeFormPageId][questionKey].time = answer?.time;
      }
      // Return the updated state
      return newState;
    });
  }

  const updateJourneySchema = async (id) => {
    const response = await getJourneyDataForUsers(id, () =>
      navigate("/404_not_found"),
    );
    if (response?.data?.journey) {
      let journeyData = JSON.parse(JSON.stringify(response?.data?.journey));
      setJourneyTriggers(journeyData?.triggers);
      setJourneyQueryParams(journeyData?.queryParams || []);
      setJourneyConfigs(journeyData?.journey_schema?.configs || {});
      setJourneyConfigsGlobal(journeyData?.journey_schema?.configs || {});

      const journeyTheme = journeyData?.journey_schema?.journeyTheme;
      journeyTheme && setCSSVariables(journeyTheme);
      journeyData = await updateSchemaWithFormRemovals(
        journeyData,
        journeyData?._id,
      );

      let schema = await updateSchemaWithFormData(journeyData?.journey_schema);

      if (schema?.theme) {
        setTheme(schema.theme);
        setCSSVariables(themes[schema.theme]);
      }
      // setTheme("theme2");
      //   setCSSVariables(themes["theme2"]);
      let { parentJourney } = schema;
      parentJourney &&
        (await mapParentSchedulerToJourney(schema?.parentJourney));

      let schedulerID = getWidgetId(journeyData);
      let prepopulatedBody = null;
      if (schedulerID && patientId) {
        prepopulatedBody = await prePopulateFieldsForPatientInfo(
          patientId,
          schedulerID,
        );
      }
      if (schedulerID && hash) {
        prepopulatedBody = await prePopulateFieldsForPatientInfoWithHash(
          hash,
          schedulerID,
        );
      }

      if (hashId && hashId !== "undefined") {
        prepopulatedBody =
          await prepopulateFieldsForPatientInfoWithHashID(hashId);
      }

      if (prepopulatedBody) {
        let updatedJourneySchema = JSON.parse(
          JSON.stringify(
            await updateJourneyDataWithPrePopulatedValues(
              schema,
              prepopulatedBody,
            ),
          ),
        );
        journeyData.journey_schema = updatedJourneySchema;
        schema = updatedJourneySchema;
      }
      await processWorkflowContextAndUpdateSchema(schema, journeyData);

      setJourneyData(journeyData);
      setJourneySchema(schema);
      setSteps(findSteps(schema));
      setActiveScreenID(schema?.screens[0]?.id);
      setActiveScreenPageID(schema?.screens[0]?.screenPages[0]?.id);
      setActiveComponent(schema?.screens[0]?.screenPages[0]?.components);
      setActiveFormPage(
        schema?.screens[0]?.screenPages[0]?.components?.form?.form_schema
          ?.formData[0],
      );
      setFirstPageFirstFormID(
        schema?.screens[0]?.screenPages[0]?.components?.form?.form_schema
          ?.formData[0]?.id,
      );
      setIsLoading(false);
      setLoaderMessage("");
    }
  };

  const setCSSVariables = (theme) => {
    const cssVariables = theme?.cssVariables || {};
    const directStyles = theme?.directStyles || {};
    for (const value in cssVariables) {
      document.documentElement.style.setProperty(
        `--${value}`,
        cssVariables[value],
      );
    }
    for (const styleProperty in directStyles) {
      document.documentElement.style[styleProperty] =
        directStyles[styleProperty];
    }
  };

  const updateSchemaWithFormData = async (schema) => {
    const updateScreenPage = async (screenPage) => {
      if (
        screenPage &&
        screenPage.components &&
        (screenPage.components?.type === "user-form" ||
          screenPage.components?.type === "standard-form")
      ) {
        let form = await fetchFormSchema(screenPage.components);
        screenPage.components.form = form;
      }
    };

    const updateScreen = async (screen) => {
      await Promise.all(screen.screenPages.map(updateScreenPage));
    };

    await Promise.all(schema?.screens?.map(updateScreen));

    return schema;
  };

  const updateSchemaWithFormRemovals = async (journeyData, journeyId) => {
    if (!journeyId) return journeyData;
    if (
      journeyId &&
      typeof journeyId !== "string" &&
      journeyId !== "68fee59e343e50187c6e7737"
    )
      return journeyData;

    const workflowContext = journeyData?.context?.workflowContext?.journeyData;
    if (!workflowContext) return journeyData;

    let key = workflowContext?.paymentMode;
    if (!key) return journeyData;

    // Hardcoded removal rules
    const removalRules = {
      inNetwork: ["682f1c451b878c3e8f5bad78", "6902e0ce343e50187c6e8187"],
      outNetwork: ["682f1c451b878c3e8f5bad78", "68ef6f49343e50187c6e5651"],
      cashPay: ["68ef6f49343e50187c6e5651", "6902e0ce343e50187c6e8187"],
    };

    // Get the list of formIds to remove for the current key
    const formIdsToRemove = removalRules[key];
    if (!formIdsToRemove) return journeyData;

    // Deep clone the schema to avoid mutating the original
    const updatedJourneyData = JSON.parse(JSON.stringify(journeyData));
    const updatedSchema = updatedJourneyData?.journey_schema;

    // Iterate through screens and filter out pages with matching formIds
    updatedSchema.screens = updatedSchema.screens.map((screen) => {
      if (screen.screenPages) {
        // Filter out pages where formId matches any in formIdsToRemove
        screen.screenPages = screen.screenPages.filter((page) => {
          const formId = page.components?.formId;
          return !formIdsToRemove.includes(formId);
        });

        // If active page was removed, set first remaining page as active
        const hasActivePage = screen.screenPages.some((page) => page.active);
        if (!hasActivePage && screen.screenPages.length > 0) {
          screen.screenPages[0].active = true;
        }
      }
      return screen;
    });

    return updatedJourneyData;
  };

  const callInitialAthenaAPIs = async () => {
    const API_URL = process.env.REACT_APP_SCHEDULER_URL;
    const getAppointmentStatusURL = `${API_URL}/api/v1/appointments/status/${hashId}`;
    const getDepartmentCheckinUrl = `${API_URL}/api/v1/checkin/${hashId}/fields/department`;
    const getAppointmentCheckinFieldsUrl = `${API_URL}/api/v1/checkin/${hashId}/fields/appointment`;
    const startCheckInUrl = `${API_URL}/api/v1/checkin/${hashId}/start`;
    const cancelCheckInUrl = `${API_URL}/api/v1/checkin/${hashId}/cancel`;

    callAthenaGetApi(getAppointmentStatusURL);
    callAthenaGetApi(getDepartmentCheckinUrl);
    callAthenaGetApi(getAppointmentCheckinFieldsUrl);
    callAthenaPostApi(startCheckInUrl);
    // callAthenaApi(cancelCheckInUrl);

    // callAthenaApi(journeyId, {
    //   resource: "AppointmentCheckin",
    //   responseSystem: "HBx",
    //   requestSystem: "HBx",
    //   method: "GET",
    //   content: {
    //     patientId: patientId,
    //     appointmentId: appointmentId,
    //   },
    // });
    // callAthenaApi(startCheckInUrl);
  };
  const checkAppointmentStatus = async (journeyId) => {
    const API_URL = process.env.REACT_APP_SCHEDULER_URL;
    const fETCH_API_URL = `${API_URL}/api/v1/appointments/status/${hashId}`;
    try {
      const response = await axios.get(fETCH_API_URL);
      // await axios.get(REASON_API_URL);
      const { appointmentStatus } = response?.data;
      const { providerId } = response?.data;
      const { reasonId } = response?.data;
      const { departmentId } = response?.data;
      const { patientTZ } = response?.data;
      const { insuranceCollected } = response?.data;
      const { paymentCollected } = response?.data;
      setPatientTZ(patientTZ);
      if (appointmentStatus !== "active") {
        setInActiveAppointment(true);
        setIsLoading(false);
        setLoaderMessage("");
      } else {
        updateJourneySchema(journeyId);
      }
      setProvider_id(providerId);
      setDepartment_id(departmentId);
      setReason_id(reasonId);
      setInsuranceCollectedStatus(insuranceCollected);
      setPaymentCollectedStatus(paymentCollected);
      return response;
    } catch (e) {
      console.log(e);
      setInActiveAppointment(true);
      setIsLoading(false);
      setLoaderMessage("");
      return { error: true };
    }
  };

  const mapParentSchedulerToJourney = async (parentJourney) => {
    let schedulerID = await fetchSchedulerIdFromParentJourney(parentJourney);
    schedulerID && setScheduler_id(schedulerID);
  };

  const fetchSchedulerIdFromParentJourney = async (parentJourney) => {
    //   const API_URL = process.env.REACT_APP_SCHEDULER_URL;
    //   const CANCEL_API_URL = `${API_URL}/api/v1/appointments/${schedulerIdForSpecificJourney}/cancel`;
    //   try {
    //     const response = await axios.get(CANCEL_API_URL, {
    //       reasonId: 41, //fixed
    //       reason: answerData?.reasonForAppointmentCancellation?.value, //input
    //       hash: hashId, //params.id
    //     });
    //     navigate("/thank-you");
    //     return response;
    //   } catch (e) {
    //     console.log(e);
    //     return { error: true };
    //   }
    return null;
  };

  const prePopulateFieldsForPatientInfo = async (patientId, schedulerID) => {
    let API_URL = `${
      process.env?.REACT_APP_SCHEDULER_URL ||
      "https://apps-sandbox.healthblox.care/scheduler"
    }/api/v1/patients/${schedulerID}/${patientId}`;
    try {
      const response = await axios.get(API_URL);
      const { HBx } = response?.data;
      const patientInfo = HBx[0];
      if (patientInfo) {
        let prePopulatedBody = {
          HBxFirstName: {
            value: patientInfo?.firstName || "",
          },
          HBxLastName: {
            value: patientInfo?.lastName || "",
          },
          HBxDob: {
            value: patientInfo?.DOB ? dayjs(new Date(patientInfo?.DOB)) : null,
          },
          gender: {
            value:
              patientInfo?.sex === "Male"
                ? "male"
                : patientInfo?.sex === "Female"
                  ? "female"
                  : "",
          },
          mobilePhone: {
            value: patientInfo?.phoneNumber?.mobile || "",
          },
          consentToCall: {
            value: patientInfo?.consentToCall ? ["consentToCall"] : null,
          },
          iAuthorizeHBxSleepToSendTextReminders: {
            value: patientInfo?.consentToText
              ? ["iAuthorizeHBxSleepToSendTextReminders"]
              : null,
          },
          HBxEmail: {
            value: patientInfo?.email?.[0] || "",
          },
          address1: {
            value: patientInfo?.address?.streetAddress || "",
          },
          city: {
            value: patientInfo?.address?.city || "",
          },
          patientStateForScheduler: {
            value: patientInfo?.address?.state || "",
          },
          zipCode: {
            value: patientInfo?.address?.ZIP || "",
          },
          country: {
            value: patientInfo?.address?.country || "",
          },
        };
        setAnswerData({ ...answerData, ...prePopulatedBody });

        setHBxFirstName(patientInfo?.firstName || "");
        setHBxLastName(patientInfo?.lastName || "");
        setHBxEmail(patientInfo?.email?.[0] || "");
        setHBxDob(patientInfo?.DOB ? dayjs(new Date(patientInfo?.DOB)) : null);
        return prePopulatedBody;
      }
      return null;
    } catch (error) {
      console.log(error);
      return null;
    }
  };

  const prePopulateFieldsForPatientInfoWithHash = async (hash, schedulerID) => {
    let API_URL = `${
      process.env?.REACT_APP_SCHEDULER_URL ||
      "https://apps-sandbox.healthblox.care/scheduler"
    }/api/v1/booking/${schedulerID}/${hash}`;
    try {
      const response = await axios.get(API_URL);
      const patientInfo = response?.data;
      if (patientInfo?.patientId) setPatient_id(patientInfo.patientId);
      if (patientInfo) {
        let prePopulatedBody = {
          HBxFirstName: {
            value: patientInfo?.firstName || "",
          },
          HBxLastName: {
            value: patientInfo?.lastName || "",
          },
          HBxDob: {
            value: patientInfo?.DOB ? dayjs(new Date(patientInfo?.DOB)) : null,
          },
          gender: {
            value:
              patientInfo?.sex === "Male"
                ? "male"
                : patientInfo?.sex === "Female"
                  ? "female"
                  : "",
          },
          mobilePhone: {
            value: patientInfo?.phoneNumber?.mobile || "",
          },
          consentToCall: {
            value: patientInfo?.consentToCall ? ["consentToCall"] : null,
          },
          iAuthorizeHBxSleepToSendTextReminders: {
            value: patientInfo?.consentToText
              ? ["iAuthorizeHBxSleepToSendTextReminders"]
              : null,
          },
          HBxEmail: {
            value: patientInfo?.email?.[0] || "",
          },
          address1: {
            value: patientInfo?.address?.streetAddress || "",
          },
          city: {
            value: patientInfo?.address?.city || "",
          },
          patientStateForScheduler: {
            value: patientInfo?.address?.state || "",
          },
          zipCode: {
            value: patientInfo?.address?.ZIP || "",
          },
          country: {
            value: patientInfo?.address?.country || "",
          },
        };
        setAnswerData({ ...answerData, ...prePopulatedBody });

        setHBxFirstName(patientInfo?.firstName || "");
        setHBxLastName(patientInfo?.lastName || "");
        setHBxEmail(patientInfo?.email?.[0] || "");
        setHBxDob(patientInfo?.DOB ? dayjs(new Date(patientInfo?.DOB)) : null);
        return prePopulatedBody;
      }
      return null;
    } catch (error) {
      console.log(error);
      return null;
    }
  };

  const prepopulateFieldsForPatientInfoWithHashID = async (hashId) => {
    const API_URL = process.env.REACT_APP_SCHEDULER_URL;
    const getPatientUrl = `${API_URL}/api/v1/checkin/${hashId}/patient`;
    const response = await callAthenaGetApi(getPatientUrl);
    const patientInfoForDemographics = response.data?.HBx[0];
    let prePopulatedBody = {
      demographicsCity: {
        value: patientInfoForDemographics?.address?.city || "",
      },
      demographicsConsentToCall: {
        value: patientInfoForDemographics?.consentToCall ? "yes" : "no",
      },
      demographicsConsentToTextYou: {
        value: patientInfoForDemographics?.consentToText ? "yes" : "no",
      },
      demographicsEmail: {
        value: patientInfoForDemographics?.email || "",
      },
      demographicsPatientFirstName: {
        value: patientInfoForDemographics?.firstName || "",
      },
      demographicsMiddleInitial: {
        value: patientInfoForDemographics?.middleName || "",
      },
      demographicsPatientLastName: {
        value: patientInfoForDemographics?.lastName || "",
      },
      demographicsMaritalStatus: {
        value: patientInfoForDemographics?.maritalStatus || "",
      },
      demographicsRace: {
        value: patientInfoForDemographics?.race || "",
      },
      demographicsEthnicity: {
        value: patientInfoForDemographics?.ethnicity || "",
      },
      demographicsStreetAddress: {
        value: patientInfoForDemographics?.address?.streetAddress || "",
      },
      demographicsZipCode: {
        value: patientInfoForDemographics?.address?.ZIP || "",
      },
      demographicsCountry: {
        value: patientInfoForDemographics?.address?.country || "",
      },
      demographicsState: {
        value: patientInfoForDemographics?.address?.state || "",
      },
      demographicsMobilePhone: {
        value: patientInfoForDemographics?.phoneNumber?.mobile || "",
      },
      demographicsWorkPhone: {
        value: patientInfoForDemographics?.phoneNumber?.office || "",
      },
      demographicsHomePhone: {
        value: patientInfoForDemographics?.phoneNumber?.home || "",
      },
      demographicsLegalGender: {
        value:
          patientInfoForDemographics?.sex === "Female"
            ? "F"
            : patientInfoForDemographics?.sex === "Male"
              ? "M"
              : "",
      },
      paymentEmail: {
        value: patientInfoForDemographics?.email?.[0] || "",
      },
      paymentAddress: {
        value: patientInfoForDemographics?.address?.streetAddress || "",
      },
      paymentZipCode: {
        value: patientInfoForDemographics?.address?.ZIP || "",
      },
      paymentCountry: {
        value: patientInfoForDemographics?.address?.country || "",
      },
      paymentState: {
        value: patientInfoForDemographics?.address?.state || "",
      },
      paymentCity: {
        value: patientInfoForDemographics?.address?.city || "",
      },
      demographicsEmergencyFirstName: {
        value: patientInfoForDemographics?.emergencyContact?.name || "",
      },
      demographicsEmergencyRelationship: {
        value: patientInfoForDemographics?.emergencyContact?.relationship || "",
      },
      demographicsEmergencyMobilePhone: {
        value: patientInfoForDemographics?.emergencyContact?.phone || "",
      },
      demographicsPreferredLanguage: {
        value: patientInfoForDemographics?.language || "",
      },
    };
    setAnswerData({ ...answerData, ...prePopulatedBody });
    return prePopulatedBody;
  };

  useEffect(() => {
    if (journeyId) {
      setJourneyId(journeyId);

      if (callAthenaApisJourneyIds.includes(journeyId)) {
        callInitialAthenaAPIs();
      }
      if (journeyIdsForStatusCheck?.includes(journeyId)) {
        checkAppointmentStatus(journeyId);
      } else {
        updateJourneySchema(journeyId);
      }
    }
    if (journeyInstanceId) {
      setJourneyInstanceId(journeyInstanceId);
      updateJourneySchemaForInstanceID(journeyInstanceId);
    }
  }, []);


  function updateJourneyDataWithPrePopulatedValues(
    journeySchema,
    prePopulatedBody,
  ) {
    // Create a deep copy of the journey data to avoid modifying the original
    const updatedJourneySchema = JSON.parse(JSON.stringify(journeySchema));

    // Get all form schemas from the journey data
    const formSchemas = extractFormSchemas(updatedJourneySchema);

    // Process each form schema
    formSchemas.forEach((formSchema) => {
      // Process each form page
      if (formSchema.formData) {
        formSchema.formData.forEach((page) => {
          // Process components within each page
          if (page.content && page.content.components) {
            processComponents(page.content.components, prePopulatedBody);
          }
        });
      }
    });

    return updatedJourneySchema;
  }

  function extractFormSchemas(journey_schema) {
    const formSchemas = [];

    // Extract the form schema directly embedded in journey_schema
    if (journey_schema && journey_schema.screens) {
      journey_schema.screens.forEach((screen) => {
        if (screen.screenPages) {
          screen.screenPages.forEach((page) => {
            if (
              page.components &&
              page.components.form &&
              page.components.form.form_schema
            ) {
              formSchemas.push(page.components.form.form_schema);
            }
          });
        }
      });
    }

    return formSchemas;
  }

  function processComponents(components, prePopulatedBody) {
    components.forEach((component) => {
      // Check if the component key exists in prePopulatedBody
      if (component.key && prePopulatedBody[component.key]) {
        // Add answer property with the prepopulated value
        component.answer = prePopulatedBody[component.key];
      }

      // Process nested components (e.g., inside containers, columns, panels)
      if (component?.components) {
        processComponents(component.components, prePopulatedBody);
      }
    });
  }

  const isLastForm = useMemo(() => {
    const screens = journeySchema?.screens;
    if (!screens?.length) return false;

    const lastScreen = screens[screens.length - 1];
    const lastScreenPages = lastScreen?.screenPages;

    if (!lastScreenPages?.length) return false;

    return (
      lastScreenPages[lastScreenPages.length - 1]?.id === activeScreenPageID
    );
  }, [journeySchema?.screens, activeScreenPageID]);

  if (!(journeyId || journeyInstanceId)) return <></>;
  return (
    <div className="journey-renderer-main-component">
      {theme && theme === "default" && (
        <div className="default-theme">
          <div className="m-auto journey-renderer-container">
            {!isLoading ? (
              <>
                {inActiveAppointment ? (
                  <>
                    <div className="w-auto">
                      <div className="w-auto p-5 text-2xl text-center h-screen bg-gray-100 py-48">
                        Appointment does not exist
                      </div>
                      <div className="bottom-bar-shadow">
                        <div className="flex justify-end pt-3 m-auto bottom-bar w-full">
                          <div
                            onClick={() => navigate("/thank-you")}
                            className="primary_button "
                          >
                            Close
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                ) : (
                  <>
                    <div className="top-bar box-shadow">
                      <div className="flex flex-row justify-between px-3 md:w-full">
                        <div className="text-center font-bold title-text md:w-2/12">
                          {journeySchema?.label || "User Journey Form"}
                        </div>
                        <div className="m-auto hidden md:block md:w-6/12">
                          <ProgressTracker
                            steps={steps}
                            currentStep={activeStep}
                          />
                        </div>
                        <div className="my-auto font-semibold md:w-3/12 ">
                          {/* {activeStep + 1} / {steps?.length} */}
                        </div>
                      </div>
                      {/* <div className="m-auto pt-5 mx-auto md:hidden">
                    <ProgressTracker steps={steps} currentStep={activeStep} />
                  </div> */}
                    </div>
                    <div className="journey-content content-padding overflow-y-visible">
                      {activeComponent &&
                      activeComponent?.form &&
                      (activeComponent?.type === "user-form" ||
                        activeComponent?.type === "standard-form") ? (
                        <div className="content-width ">
                          <FormRenderer
                            formData={activeComponent}
                            handleNextScreenPage={handleNext}
                            handleBackScreenPage={handleBack}
                            activeFormPageData={activeFormPage}
                            firstPageFirstFormID={firstPageFirstFormID}
                            isLastForm={isLastForm}
                          />
                        </div>
                      ) : activeComponent &&
                        activeComponent?.type === "widget" ? (
                        <div className="flex justify-center content-width ">
                          {activeComponent?.answer &&
                          activeComponent?.answer?.status ===
                            "payment-successful" ? (
                            <div className="">
                              <div className="flex flex-col">
                                <div className="text-center font-semibold text-lg py-3 shadow my-5 px-24 rounded bg-gray-100">
                                  {activeComponent?.answer?.message}
                                </div>
                                <div className="flex justify-between py-8">
                                  <button
                                    disabled={isLoading}
                                    onClick={handleBack}
                                    className="text_button"
                                  >
                                    Back
                                  </button>
                                  <button
                                    disabled={isLoading}
                                    onClick={handleNext}
                                    className="primary_button"
                                  >
                                    Next
                                  </button>
                                </div>
                              </div>
                            </div>
                          ) : (
                            <>
                              <div className="content-width ">
                                <StripeCheckout
                                  org_id={activeComponent?.widget?.org_id}
                                  amount={activeComponent?.widget?.amount || 0}
                                  widget={activeComponent?.widget}
                                  handleNextScreenPage={handleNext}
                                  handleBackScreenPage={handleBack}
                                  setAnswerForWidget={setAnswerForWidget}
                                />
                              </div>
                            </>
                          )}
                        </div>
                      ) : activeComponent &&
                        activeComponent?.type === "scheduler-widget" ? (
                        <div className="flex justify-center">
                          {activeComponent?.answer &&
                          activeComponent?.answer?.status ===
                            "appointment-successful" ? (
                            <div className="content-width">
                              <div className="flex flex-col">
                                <div className="text-center font-semibold text-lg py-3 shadow my-5 px-24 rounded bg-gray-100">
                                  {activeComponent?.answer?.message}
                                </div>
                                <div className="flex justify-between py-8">
                                  <button
                                    disabled={isLoading}
                                    onClick={handleBack}
                                    className="text_button"
                                  >
                                    Back
                                  </button>
                                  <button
                                    disabled={isLoading}
                                    onClick={handleNext}
                                    className="primary_button"
                                  >
                                    Next
                                  </button>
                                </div>
                              </div>
                            </div>
                          ) : (
                            <>
                              <div className="w-full">
                                <SchedulerWidget
                                  widget={activeComponent?.widget}
                                  handleNextScreenPage={handleNext}
                                  handleBackScreenPage={handleBack}
                                  setAnswerForWidget={
                                    setAnswerForSchedulerWidget
                                  }
                                />
                              </div>
                            </>
                          )}
                        </div>
                      ) : (
                        <></>
                      )}
                    </div>
                  </>
                )}
              </>
            ) : (
              <div className="flex flex-col  h-screen justify-center items-center">
                <Loader message={loaderMessage} />
              </div>
            )}
          </div>
        </div>
      )}

      {theme && theme === "theme1" && (
        <div className="theme1-theme">
          <div className="m-auto journey-renderer-container">
            {!isLoading ? (
              <>
                <div className="top-bar box-shadow">
                  <div className="flex flex-row justify-between px-3 md:w-full">
                    <div className="text-center font-bold title-text md:w-3/12">
                      {journeySchema?.label || "User Journey Form"}
                    </div>
                    <div className="m-auto hidden md:block md:w-6/12">
                      <ProgressTracker steps={steps} currentStep={activeStep} />
                    </div>
                    <div className="my-auto font-semibold md:w-3/12 ">
                      {activeStep + 1} / {steps?.length}
                    </div>
                  </div>
                  <div className="m-auto pt-5 mx-auto md:hidden">
                    <ProgressTracker steps={steps} currentStep={activeStep} />
                  </div>
                </div>
                <div className="content">
                  {activeComponent &&
                  activeComponent?.form &&
                  (activeComponent?.type === "user-form" ||
                    activeComponent?.type === "standard-form") ? (
                    <div className="content-width ">
                      <FormRenderer
                        formData={activeComponent}
                        handleNextScreenPage={handleNext}
                        handleBackScreenPage={handleBack}
                        activeFormPageData={activeFormPage}
                        firstPageFirstFormID={firstPageFirstFormID}
                        isLastForm={isLastForm}
                      />
                    </div>
                  ) : activeComponent && activeComponent?.type === "widget" ? (
                    <div className="flex justify-center content-width ">
                      {activeComponent?.answer &&
                      activeComponent?.answer?.status ===
                        "payment-successful" ? (
                        <div className="">
                          <div className="flex flex-col">
                            <div className="text-center font-semibold text-lg py-3 shadow my-5 px-24 rounded bg-gray-100">
                              {activeComponent?.answer?.message}
                            </div>
                            <div className="flex justify-between py-8">
                              <button
                                disabled={isLoading}
                                onClick={handleBack}
                                className="text_button"
                              >
                                Back
                              </button>
                              <button
                                disabled={isLoading}
                                onClick={handleNext}
                                className="primary_button"
                              >
                                Next
                              </button>
                            </div>
                          </div>
                        </div>
                      ) : (
                        <>
                          <div className="content-width ">
                            <StripeCheckout
                              org_id={activeComponent?.widget?.org_id}
                              amount={activeComponent?.widget?.amount || 0}
                              widget={activeComponent?.widget}
                              handleNextScreenPage={handleNext}
                              handleBackScreenPage={handleBack}
                              setAnswerForWidget={setAnswerForWidget}
                            />
                          </div>
                        </>
                      )}
                    </div>
                  ) : activeComponent &&
                    activeComponent?.type === "scheduler-widget" ? (
                    <div className="flex justify-center">
                      {activeComponent?.answer &&
                      activeComponent?.answer?.status ===
                        "appointment-successful" ? (
                        <div className="content-width">
                          <div className="flex flex-col">
                            <div className="text-center font-semibold text-lg py-3 shadow my-5 px-24 rounded bg-gray-100">
                              {activeComponent?.answer?.message}
                            </div>
                            <div className="flex justify-between py-8">
                              <button
                                disabled={isLoading}
                                onClick={handleBack}
                                className="text_button"
                              >
                                Back
                              </button>
                              <button
                                disabled={isLoading}
                                onClick={handleNext}
                                className="primary_button"
                              >
                                Next
                              </button>
                            </div>
                          </div>
                        </div>
                      ) : (
                        <>
                          <div className="w-full">
                            <SchedulerWidget
                              widget={activeComponent?.widget}
                              handleNextScreenPage={handleNext}
                              handleBackScreenPage={handleBack}
                              setAnswerForWidget={setAnswerForSchedulerWidget}
                            />
                          </div>
                        </>
                      )}
                    </div>
                  ) : (
                    <></>
                  )}
                </div>
              </>
            ) : (
              <div className="">
                <Loader message={loaderMessage} />
              </div>
            )}
            {openConfirmationModal ? <></> : <></>}
          </div>
        </div>
      )}

      {theme && theme === "theme2" && (
        <div className="theme2-theme">
          <>
            {components && components === "landing" ? (
              <>
                <LandingPage />
              </>
            ) : (
              <></>
            )}
            {components && components === "login" ? (
              <>
                <LoginPage />
              </>
            ) : (
              <></>
            )}
            {components && components === "loginDetails" ? (
              <>
                <LoginDetailsPage />
              </>
            ) : (
              <></>
            )}
            {components && components === "journey" ? (
              <div className="m-auto journey-renderer-container">
                <>
                  {!isLoading ? (
                    <>
                      {/* <div className="top-bar box-shadow">
            <div className="flex flex-row justify-between px-3 md:w-full">
              <div className="text-center font-bold title-text md:w-3/12">
                {journeySchema?.label || "User Journey Form"}
              </div>
              <div className="m-auto hidden md:block md:w-6/12">
                <ProgressTracker steps={steps} currentStep={activeStep} />
              </div>
              <div className="my-auto font-semibold md:w-3/12 ">
                {activeStep + 1} / {steps?.length}
              </div>
            </div>
            <div className="m-auto pt-5 mx-auto md:hidden">
              <ProgressTracker steps={steps} currentStep={activeStep} />
            </div>
          </div> */}
                      <div className="content">
                        {activeComponent &&
                        activeComponent?.form &&
                        (activeComponent?.type === "user-form" ||
                          activeComponent?.type === "standard-form") ? (
                          <div className="content-width pb-20">
                            <FormRenderer
                              formData={activeComponent}
                              handleNextScreenPage={handleNext}
                              handleBackScreenPage={handleBack}
                              activeFormPageData={activeFormPage}
                              firstPageFirstFormID={firstPageFirstFormID}
                              isLastForm={isLastForm}
                            />
                          </div>
                        ) : activeComponent &&
                          activeComponent?.type === "widget" ? (
                          <div className="flex justify-center content-width ">
                            {activeComponent?.answer &&
                            activeComponent?.answer?.status ===
                              "payment-successful" ? (
                              <div className="">
                                <div className="flex flex-col">
                                  <div className="text-center font-semibold text-lg py-3 shadow my-5 px-24 rounded bg-gray-100">
                                    {activeComponent?.answer?.message}
                                  </div>
                                  <div className="flex justify-between py-8">
                                    <button
                                      disabled={isLoading}
                                      onClick={handleBack}
                                      className="text_button"
                                    >
                                      Back
                                    </button>
                                    <button
                                      disabled={isLoading}
                                      onClick={handleNext}
                                      className="primary_button"
                                    >
                                      Next
                                    </button>
                                  </div>
                                </div>
                              </div>
                            ) : (
                              <>
                                <div className="content-width w-full pt-5">
                                  <StripeCheckout
                                    org_id={activeComponent?.widget?.org_id}
                                    amount={
                                      activeComponent?.widget?.amount || 0
                                    }
                                    widget={activeComponent?.widget}
                                    handleNextScreenPage={handleNext}
                                    handleBackScreenPage={handleBack}
                                    setAnswerForWidget={setAnswerForWidget}
                                  />
                                </div>
                              </>
                            )}
                          </div>
                        ) : activeComponent &&
                          activeComponent?.type === "scheduler-widget" ? (
                          <div className="flex justify-center">
                            {activeComponent?.answer &&
                            activeComponent?.answer?.status ===
                              "appointment-successful" ? (
                              <div className="content-width">
                                <div className="flex flex-col">
                                  <div className="text-center font-semibold text-lg py-3 shadow my-5 px-24 rounded bg-gray-100">
                                    {activeComponent?.answer?.message}
                                  </div>
                                  <div className="flex justify-between py-8">
                                    <button
                                      disabled={isLoading}
                                      onClick={handleBack}
                                      className="text_button"
                                    >
                                      Back
                                    </button>
                                    <button
                                      disabled={isLoading}
                                      onClick={handleNext}
                                      className="primary_button"
                                    >
                                      Next
                                    </button>
                                  </div>
                                </div>
                              </div>
                            ) : (
                              <>
                                <div className="w-full">
                                  <NewSchedulerWidget
                                    widget={activeComponent?.widget}
                                    handleNextScreenPage={handleNext}
                                    handleBackScreenPage={handleBack}
                                    setAnswerForWidget={
                                      setAnswerForSchedulerWidget
                                    }
                                  />
                                </div>
                              </>
                            )}
                          </div>
                        ) : (
                          <></>
                        )}
                      </div>
                    </>
                  ) : (
                    <div className="">
                      <Loader message={loaderMessage} />
                    </div>
                  )}
                </>
              </div>
            ) : (
              <></>
            )}{" "}
          </>
        </div>
      )}

      {theme && theme === "theme3" && (
        <div className="theme3-theme">
          <div className="m-auto journey-renderer-container">
            <>
              {!isLoading ? (
                <>
                  <div className="content">
                    {activeComponent &&
                    activeComponent?.form &&
                    (activeComponent?.type === "user-form" ||
                      activeComponent?.type === "standard-form") ? (
                      <div className="content-width pb-20">
                        <FormRenderer
                          formData={activeComponent}
                          handleNextScreenPage={handleNext}
                          handleBackScreenPage={handleBack}
                          activeFormPageData={activeFormPage}
                          firstPageFirstFormID={firstPageFirstFormID}
                          formClass={"flex gap-4"}
                          isLastForm={isLastForm}
                        />
                      </div>
                    ) : activeComponent &&
                      activeComponent?.type === "widget" ? (
                      <div className="flex justify-center content-width ">
                        {activeComponent?.answer &&
                        activeComponent?.answer?.status ===
                          "payment-successful" ? (
                          <div className="">
                            <div className="flex flex-col">
                              <div className="text-center font-semibold text-lg py-3 shadow my-5 px-24 rounded bg-gray-100">
                                {activeComponent?.answer?.message}
                              </div>
                              <div className="flex justify-between py-8">
                                <button
                                  disabled={isLoading}
                                  onClick={handleBack}
                                  className="text_button"
                                >
                                  Back
                                </button>
                                <button
                                  disabled={isLoading}
                                  onClick={handleNext}
                                  className="primary_button"
                                >
                                  Next
                                </button>
                              </div>
                            </div>
                          </div>
                        ) : (
                          <>
                            <div className="content-width w-full pt-5">
                              <StripeCheckout
                                org_id={activeComponent?.widget?.org_id}
                                amount={activeComponent?.widget?.amount || 0}
                                widget={activeComponent?.widget}
                                handleNextScreenPage={handleNext}
                                handleBackScreenPage={handleBack}
                                setAnswerForWidget={setAnswerForWidget}
                              />
                            </div>
                          </>
                        )}
                      </div>
                    ) : activeComponent &&
                      activeComponent?.type === "scheduler-widget" ? (
                      <div className="flex justify-center">
                        {activeComponent?.answer &&
                        activeComponent?.answer?.status ===
                          "appointment-successful" ? (
                          <div className="content-width">
                            <div className="flex flex-col">
                              <div className="text-center font-semibold text-lg py-3 shadow my-5 px-24 rounded bg-gray-100">
                                {activeComponent?.answer?.message}
                              </div>
                              <div className="flex justify-between py-8">
                                <button
                                  disabled={isLoading}
                                  onClick={handleBack}
                                  className="text_button"
                                >
                                  Back
                                </button>
                                <button
                                  disabled={isLoading}
                                  onClick={handleNext}
                                  className="primary_button"
                                >
                                  Next
                                </button>
                              </div>
                            </div>
                          </div>
                        ) : (
                          <>
                            <div className="w-full">
                              <SchedulerWidget
                                widget={activeComponent?.widget}
                                handleNextScreenPage={handleNext}
                                handleBackScreenPage={handleBack}
                                setAnswerForWidget={setAnswerForSchedulerWidget}
                              />
                            </div>
                          </>
                        )}
                      </div>
                    ) : (
                      <></>
                    )}
                  </div>
                </>
              ) : (
                <div className="">
                  <Loader message={loaderMessage} />
                </div>
              )}
            </>
          </div>
        </div>
      )}

      {theme && theme === "theme4" && (
        <div className="theme4-theme">
          <div className="m-auto journey-renderer-container">
            {!isLoading ? (
              <>
                <div className="top-bar box-shadow">
                  <div className="flex flex-row justify-between px-3 md:w-full">
                    <div className="text-center font-bold title-text hidden md:block md:w-3/12">
                      <img
                        src={cpapLogo}
                        style={{ objectFit: "contain" }}
                        className="h-20 mx-auto "
                      />
                    </div>
                    <div className="m-auto hidden md:block md:w-6/12">
                      <ProgressTracker steps={steps} currentStep={activeStep} />
                    </div>
                    <div className="my-auto font-semibold md:w-3/12 ">
                      {/* {activeStep + 1} / {steps?.length} */}
                    </div>
                  </div>
                  <div className="m-auto pt-5 mx-auto md:hidden">
                    <ProgressTracker steps={steps} currentStep={activeStep} />
                  </div>
                </div>
                <div className="journey-content py-24">
                  {activeComponent &&
                  activeComponent?.form &&
                  (activeComponent?.type === "user-form" ||
                    activeComponent?.type === "standard-form") ? (
                    <div className="content-width ">
                      <FormRenderer
                        formData={activeComponent}
                        handleNextScreenPage={handleNext}
                        handleBackScreenPage={handleBack}
                        activeFormPageData={activeFormPage}
                        firstPageFirstFormID={firstPageFirstFormID}
                        isLastForm={isLastForm}
                      />
                    </div>
                  ) : activeComponent && activeComponent?.type === "widget" ? (
                    <div className="flex justify-center content-width ">
                      {activeComponent?.answer &&
                      activeComponent?.answer?.status ===
                        "payment-successful" ? (
                        <div className="">
                          <div className="flex flex-col">
                            <div className="text-center font-semibold text-lg py-3 shadow my-5 px-24 rounded bg-gray-100">
                              {activeComponent?.answer?.message}
                            </div>
                            <div className="flex justify-between py-8">
                              <button
                                disabled={isLoading}
                                onClick={handleBack}
                                className="text_button"
                              >
                                Back
                              </button>
                              <button
                                disabled={isLoading}
                                onClick={handleNext}
                                className="primary_button"
                              >
                                Next
                              </button>
                            </div>
                          </div>
                        </div>
                      ) : (
                        <>
                          <div className="content-width ">
                            <StripeCheckout
                              org_id={activeComponent?.widget?.org_id}
                              amount={activeComponent?.widget?.amount || 0}
                              widget={activeComponent?.widget}
                              handleNextScreenPage={handleNext}
                              handleBackScreenPage={handleBack}
                              setAnswerForWidget={setAnswerForWidget}
                            />
                          </div>
                        </>
                      )}
                    </div>
                  ) : activeComponent &&
                    activeComponent?.type === "scheduler-widget" ? (
                    <div className="flex justify-center">
                      {activeComponent?.answer &&
                      activeComponent?.answer?.status ===
                        "appointment-successful" ? (
                        <div className="content-width">
                          <div className="flex flex-col">
                            <div className="text-center font-semibold text-lg py-3 shadow my-5 px-24 rounded bg-gray-100">
                              {activeComponent?.answer?.message}
                            </div>
                            <div className="flex justify-between py-8">
                              <button
                                disabled={isLoading}
                                onClick={handleBack}
                                className="text_button"
                              >
                                Back
                              </button>
                              <button
                                disabled={isLoading}
                                onClick={handleNext}
                                className="primary_button"
                              >
                                Next
                              </button>
                            </div>
                          </div>
                        </div>
                      ) : (
                        <>
                          <div className="w-full">
                            <SchedulerWidget
                              widget={activeComponent?.widget}
                              handleNextScreenPage={handleNext}
                              handleBackScreenPage={handleBack}
                              setAnswerForWidget={setAnswerForSchedulerWidget}
                            />
                          </div>
                        </>
                      )}
                    </div>
                  ) : (
                    <></>
                  )}
                </div>
              </>
            ) : (
              <div className="">
                <Loader message={loaderMessage} />
              </div>
            )}
          </div>
        </div>
      )}

      {theme && theme === "themeSynaptrixDemo" && (
        <div className="default-theme">
          <div className="m-auto journey-renderer-container">
            {!isLoading ? (
              <>
                {inActiveAppointment ? (
                  <>
                    <div className="w-auto">
                      <div className="w-auto p-5 text-2xl text-center h-screen bg-gray-100 py-48">
                        Appointment does not exist
                      </div>
                      <div className="bottom-bar-shadow">
                        <div className="flex justify-end pt-3 m-auto bottom-bar w-full">
                          <div
                            onClick={() => navigate("/thank-you")}
                            className="primary_button "
                          >
                            Close
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                ) : (
                  <>
                    <div className="top-bar box-shadow flex">
                      <div className="flex flex-row justify-between px-3 md:w-full">
                        {/* <div className="text-center font-bold title-text md:w-3/12">
                          {!journeySchema?.hideLabel ? (
                            <span>
                              {journeySchema?.label || "User Journey Form"}
                            </span>
                          ) : (
                            <></>
                          )}
                        </div> */}
                        {journeyConfigs?.logo && journeyConfigs.logo !== "" ? (
                          <>
                            {" "}
                            <div className="flex items-center justify-center md:w-3/12">
                              <img
                                src={journeyConfigs.logo}
                                alt="Logo"
                                className="max-w-28 max-h-[5rem] md:max-h-[6rem] w-auto h-auto object-contain"
                              />
                            </div>
                          </>
                        ) : (
                          <></>
                        )}
                        <div
                          className={`m-auto hidden md:block ${
                            journeyConfigs?.logo ? "md:w-6/12" : "md:w-12/12"
                          } overflow-hidden`}
                        >
                          <ProgressTracker
                            steps={steps}
                            currentStep={activeStep}
                          />
                        </div>
                        {journeyConfigs?.logo && journeyConfigs.logo !== "" ? (
                          <div className="flex items-center justify-center md:w-3/12"></div>
                        ) : (
                          <></>
                        )}
                      </div>
                      <div className="m-auto pt-5 mx-auto md:hidden"></div>
                    </div>
                    <div
                      className={`journey-content content-padding overflow-y-visible ${
                        deviceType !== "desktop" &&
                        !(journeyConfigs?.logo && journeyConfigs.logo !== "")
                          ? "content-padding-top-0"
                          : ""
                      }`}
                    >
                      {activeComponent &&
                      activeComponent?.form &&
                      (activeComponent?.type === "user-form" ||
                        activeComponent?.type === "standard-form") ? (
                        <div className="content-width ">
                          <FormRenderer
                            formData={activeComponent}
                            handleNextScreenPage={handleNext}
                            handleBackScreenPage={handleBack}
                            activeFormPageData={activeFormPage}
                            firstPageFirstFormID={firstPageFirstFormID}
                            isLastForm={isLastForm}
                          />
                        </div>
                      ) : activeComponent &&
                        activeComponent?.type === "widget" ? (
                        <div className="flex justify-center content-width ">
                          {activeComponent?.answer &&
                          activeComponent?.answer?.status ===
                            "payment-successful" ? (
                            <div className="">
                              <div className="flex flex-col">
                                <div className="text-center font-semibold text-lg py-3 shadow my-5 px-24 rounded bg-gray-100">
                                  {activeComponent?.answer?.message}
                                </div>
                                <div className="flex justify-between py-8">
                                  <button
                                    disabled={isLoading}
                                    onClick={handleBack}
                                    className="text_button"
                                  >
                                    Back
                                  </button>
                                  <button
                                    disabled={isLoading}
                                    onClick={handleNext}
                                    className="primary_button"
                                  >
                                    Next
                                  </button>
                                </div>
                              </div>
                            </div>
                          ) : (
                            <>
                              <div className="content-width ">
                                <StripeCheckout
                                  org_id={activeComponent?.widget?.org_id}
                                  amount={activeComponent?.widget?.amount || 0}
                                  widget={activeComponent?.widget}
                                  handleNextScreenPage={handleNext}
                                  handleBackScreenPage={handleBack}
                                  setAnswerForWidget={setAnswerForWidget}
                                />
                              </div>
                            </>
                          )}
                        </div>
                      ) : activeComponent &&
                        activeComponent?.type === "scheduler-widget" ? (
                        <div className="flex justify-center">
                          {activeComponent?.answer &&
                          activeComponent?.answer?.status ===
                            "appointment-successful" ? (
                            <div className="content-width">
                              <div className="flex flex-col">
                                <div className="text-center font-semibold text-lg py-3 shadow my-5 px-24 rounded bg-gray-100">
                                  {activeComponent?.answer?.message}
                                </div>
                                <div className="flex justify-between py-8">
                                  <button
                                    disabled={isLoading}
                                    onClick={handleBack}
                                    className="text_button"
                                  >
                                    Back
                                  </button>
                                  <button
                                    disabled={isLoading}
                                    onClick={handleNext}
                                    className="primary_button"
                                  >
                                    Next
                                  </button>
                                </div>
                              </div>
                            </div>
                          ) : (
                            <>
                              <div className="w-full">
                                <SchedulerWidget
                                  widget={activeComponent?.widget}
                                  handleNextScreenPage={handleNext}
                                  handleBackScreenPage={handleBack}
                                  setAnswerForWidget={
                                    setAnswerForSchedulerWidget
                                  }
                                />
                              </div>
                            </>
                          )}
                        </div>
                      ) : (
                        <></>
                      )}
                    </div>
                  </>
                )}
              </>
            ) : (
              <div className="flex flex-col  h-screen justify-center items-center">
                <Loader message={loaderMessage} />
              </div>
            )}
          </div>
        </div>
      )}

      {theme && theme === "themeSynaptrixDemoForCpap" && (
        <div className="default-theme">
          <div className="m-auto journey-renderer-container">
            {!isLoading ? (
              <>
                {inActiveAppointment ? (
                  <>
                    <div className="w-auto">
                      <div className="w-auto p-5 text-2xl text-center h-screen bg-gray-100 py-48">
                        Appointment does not exist
                      </div>
                      <div className="bottom-bar-shadow">
                        <div className="flex justify-end pt-3 m-auto bottom-bar w-full">
                          <div
                            onClick={() => navigate("/thank-you")}
                            className="primary_button "
                          >
                            Close
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                ) : (
                  <>
                    <div className="top-bar box-shadow">
                      <div className="flex flex-row justify-between px-3 md:w-full">
                        <div className="text-center font-bold title-text md:w-3/12">
                          {!journeySchema?.hideLabel ? (
                            <span>
                              {journeySchema?.label || "User Journey Form"}
                            </span>
                          ) : (
                            <></>
                          )}
                        </div>
                        <div className="m-auto hidden md:block md:w-6/12">
                          <ProgressTracker
                            steps={steps}
                            currentStep={activeStep}
                          />
                        </div>
                        <div className="my-auto font-semibold md:w-3/12 ">
                          {/* {activeStep + 1} / {steps?.length} */}
                          {journeySchema?.showDummyLogo ? (
                            <svg
                              className="w-40 mx-auto"
                              xmlns="http://www.w3.org/2000/svg"
                              width="187"
                              height="40"
                              fill="none"
                              viewBox="0 0 187 40"
                            >
                              <path
                                fill="#3A724F"
                                fill-rule="evenodd"
                                d="M19.87 4.567 22.507 0l7.476 4.317-2.636 4.566c-.463.801.23 1.775 1.138 1.6l5.052-.975 1.635 8.477-5.052.974c-8.172 1.576-14.411-7.184-10.25-14.392Z"
                                clip-rule="evenodd"
                              ></path>
                              <path
                                fill="#DC8E43"
                                fill-rule="evenodd"
                                d="M15.302 35.433 12.665 40l-7.477-4.316 2.637-4.567c.463-.801-.23-1.775-1.139-1.6l-5.051.974L0 22.015l5.052-.974c8.172-1.576 14.41 7.184 10.25 14.392Z"
                                clip-rule="evenodd"
                              ></path>
                              <path
                                fill="#14424C"
                                fill-rule="evenodd"
                                d="M15.53 4.567 12.894 0 5.417 4.317l2.637 4.566c.462.801-.23 1.775-1.139 1.6l-5.052-.975L.23 17.985l5.051.974c8.173 1.576 14.412-7.184 10.25-14.392Z"
                                clip-rule="evenodd"
                              ></path>
                              <path
                                fill="#C85D1B"
                                fill-rule="evenodd"
                                d="M19.65 35.433 22.285 40l7.477-4.316-2.637-4.567c-.462-.801.23-1.775 1.139-1.6l5.051.974 1.635-8.476-5.052-.974c-8.172-1.576-14.41 7.184-10.25 14.392Z"
                                clip-rule="evenodd"
                              ></path>
                              <path
                                fill="#14424C"
                                d="M163.114 30.153v-8.5c0-1.178.271-2.235.813-3.17.561-.954 1.356-1.702 2.385-2.245 1.029-.542 2.254-.813 3.675-.813a7.23 7.23 0 0 1 1.964.252c.599.15 1.141.365 1.627.645.505.262.935.58 1.291.954h.056a5.5 5.5 0 0 1 1.29-.954 6.772 6.772 0 0 1 1.656-.645 7.541 7.541 0 0 1 1.992-.252c1.421 0 2.646.27 3.675.813 1.028.543 1.823 1.29 2.384 2.245.562.935.842 1.991.842 3.17v8.5h-4.377v-8.36c0-.467-.121-.888-.364-1.262a2.663 2.663 0 0 0-.926-.954 2.508 2.508 0 0 0-1.347-.365c-.505 0-.963.122-1.374.365a2.654 2.654 0 0 0-.926.954 2.4 2.4 0 0 0-.337 1.262v8.36h-4.348v-8.36c0-.467-.122-.888-.365-1.262a2.585 2.585 0 0 0-.954-.954 2.508 2.508 0 0 0-1.347-.365c-.505 0-.963.122-1.374.365a2.654 2.654 0 0 0-.926.954 2.41 2.41 0 0 0-.337 1.262v8.36h-4.348ZM153.603 30.49c-1.477 0-2.759-.28-3.843-.842-1.066-.58-1.889-1.356-2.469-2.328-.58-.991-.87-2.086-.87-3.283v-8.276h4.349v8.164c0 .505.121.973.364 1.403.243.411.571.748.982 1.01.43.243.917.365 1.459.365.524 0 .991-.122 1.403-.365.43-.262.767-.599 1.01-1.01.243-.43.365-.898.365-1.403v-8.164h4.348v8.276c0 1.197-.281 2.292-.842 3.283-.561.972-1.374 1.749-2.44 2.328-1.048.561-2.32.842-3.816.842ZM132.414 30.153v-3.45h6.93c.187 0 .355-.038.505-.113.149-.093.271-.215.364-.364a.93.93 0 0 0 0-.982.9.9 0 0 0-.364-.337.934.934 0 0 0-.505-.14h-2.525c-.936 0-1.787-.15-2.553-.449a4.052 4.052 0 0 1-1.796-1.459c-.43-.673-.645-1.543-.645-2.609 0-.823.196-1.571.589-2.244a4.76 4.76 0 0 1 1.655-1.628 4.568 4.568 0 0 1 2.329-.617h6.929v3.479h-6.256a.97.97 0 0 0-.673.253.841.841 0 0 0-.253.617c0 .262.085.486.253.673a.97.97 0 0 0 .673.253h2.469c1.047 0 1.945.159 2.693.476.767.3 1.356.786 1.768 1.46.43.673.645 1.542.645 2.608 0 .842-.215 1.609-.645 2.3a4.613 4.613 0 0 1-1.684 1.656c-.692.412-1.477.617-2.356.617h-7.547ZM122.94 15.425c1.216 0 2.291.196 3.226.589a6.41 6.41 0 0 1 2.413 1.627 6.993 6.993 0 0 1 1.543 2.469c.355.935.533 1.973.533 3.114 0 1.421-.299 2.684-.898 3.787a6.471 6.471 0 0 1-2.412 2.553c-1.029.617-2.226.926-3.591.926-.58 0-1.132-.075-1.656-.224a5.312 5.312 0 0 1-1.402-.646 3.9 3.9 0 0 1-1.038-1.038h-.085v7.66h-4.348V23.223c0-1.59.318-2.965.954-4.124a6.666 6.666 0 0 1 2.693-2.694c1.16-.654 2.516-.981 4.068-.981Zm0 3.759c-.673 0-1.262.168-1.767.505-.487.318-.861.767-1.123 1.347-.261.56-.392 1.197-.392 1.907 0 .711.131 1.347.392 1.908.262.561.636 1.01 1.123 1.347.505.318 1.094.477 1.767.477.673 0 1.253-.16 1.739-.477a3.297 3.297 0 0 0 1.123-1.347c.28-.561.42-1.197.42-1.908 0-.71-.14-1.346-.42-1.907-.262-.58-.636-1.03-1.123-1.347-.486-.337-1.066-.505-1.739-.505ZM108.617 30.153V15.761h4.377v14.392h-4.377Zm2.188-16.019c-.692 0-1.29-.252-1.795-.757-.505-.505-.758-1.104-.758-1.796s.253-1.29.758-1.795c.505-.524 1.103-.786 1.795-.786s1.291.262 1.796.786c.505.505.757 1.103.757 1.795s-.252 1.29-.757 1.796c-.505.505-1.104.757-1.796.757ZM99.105 30.49c-1.477 0-2.805-.327-3.984-.982a7.462 7.462 0 0 1-2.805-2.693c-.673-1.141-1.01-2.422-1.01-3.844 0-1.44.337-2.721 1.01-3.843a7.462 7.462 0 0 1 2.805-2.693c1.179-.674 2.507-1.01 3.984-1.01 1.478 0 2.796.336 3.956 1.01a7.25 7.25 0 0 1 2.777 2.693c.692 1.122 1.038 2.403 1.038 3.843 0 1.422-.346 2.703-1.038 3.844a7.25 7.25 0 0 1-2.777 2.693c-1.178.655-2.497.982-3.956.982Zm0-3.787c.692 0 1.291-.169 1.796-.505a3.424 3.424 0 0 0 1.178-1.347c.281-.561.421-1.197.421-1.908 0-.692-.14-1.318-.421-1.88a3.423 3.423 0 0 0-1.178-1.346c-.505-.337-1.104-.505-1.796-.505s-1.3.168-1.823.505a3.428 3.428 0 0 0-1.179 1.347 4.144 4.144 0 0 0-.42 1.88c0 .71.14 1.346.42 1.907a3.43 3.43 0 0 0 1.179 1.347c.523.336 1.131.505 1.823.505ZM77.174 35.849v-3.732h7.181c.281 0 .515-.093.702-.28a.83.83 0 0 0 .28-.646v-3.17h-.084a6.59 6.59 0 0 1-1.206 1.094c-.412.3-.88.524-1.403.674a6.023 6.023 0 0 1-1.711.224c-1.272 0-2.413-.3-3.423-.898-.991-.617-1.777-1.468-2.357-2.553-.56-1.084-.841-2.319-.841-3.703 0-1.365.29-2.609.87-3.731.598-1.122 1.468-2.02 2.609-2.693 1.14-.674 2.534-1.01 4.18-1.01 1.571 0 2.927.327 4.068.982a6.624 6.624 0 0 1 2.693 2.72c.636 1.16.954 2.526.954 4.097v8.416c0 1.29-.383 2.31-1.15 3.058-.748.767-1.786 1.15-3.114 1.15h-8.248Zm4.825-9.483c.673 0 1.253-.15 1.74-.449a3.18 3.18 0 0 0 1.121-1.262 3.834 3.834 0 0 0 .393-1.74c0-.673-.13-1.29-.392-1.851-.262-.561-.636-1.001-1.123-1.319-.486-.337-1.066-.505-1.74-.505-.654 0-1.234.159-1.739.477-.486.318-.86.748-1.122 1.29-.261.543-.392 1.15-.392 1.824 0 .655.13 1.253.392 1.796.262.523.636.944 1.123 1.262.504.318 1.084.477 1.739.477ZM65.473 30.49c-1.477 0-2.805-.327-3.983-.982a7.46 7.46 0 0 1-2.806-2.693c-.673-1.141-1.01-2.422-1.01-3.844 0-1.44.337-2.721 1.01-3.843a7.46 7.46 0 0 1 2.806-2.693c1.178-.674 2.506-1.01 3.983-1.01 1.478 0 2.796.336 3.956 1.01a7.252 7.252 0 0 1 2.777 2.693c.692 1.122 1.038 2.403 1.038 3.843 0 1.422-.346 2.703-1.038 3.844a7.252 7.252 0 0 1-2.777 2.693c-1.178.655-2.497.982-3.956.982Zm0-3.787c.692 0 1.29-.169 1.796-.505a3.43 3.43 0 0 0 1.178-1.347c.28-.561.42-1.197.42-1.908 0-.692-.14-1.318-.42-1.88a3.429 3.429 0 0 0-1.178-1.346c-.505-.337-1.104-.505-1.796-.505s-1.3.168-1.823.505a3.428 3.428 0 0 0-1.179 1.347 4.145 4.145 0 0 0-.42 1.88c0 .71.14 1.346.42 1.907a3.43 3.43 0 0 0 1.179 1.347c.523.336 1.131.505 1.823.505ZM51.547 30.153c-1.216 0-2.282-.27-3.198-.813a5.763 5.763 0 0 1-2.132-2.16c-.505-.898-.758-1.89-.758-2.974V10.515h4.713v14.027c0 .45.16.842.477 1.179.318.336.71.505 1.178.505h5.19v3.927h-5.47Z"
                              ></path>
                            </svg>
                          ) : (
                            <img src={cpapLogo} className="w-36 mx-auto" />
                          )}
                        </div>
                      </div>
                      <div className="m-auto pt-5 mx-auto md:hidden">
                        <ProgressTracker
                          steps={steps}
                          currentStep={activeStep}
                        />
                      </div>
                    </div>
                    <div className="journey-content content-padding overflow-y-visible">
                      {activeComponent &&
                      activeComponent?.form &&
                      (activeComponent?.type === "user-form" ||
                        activeComponent?.type === "standard-form") ? (
                        <div className="content-width ">
                          <FormRenderer
                            formData={activeComponent}
                            handleNextScreenPage={handleNext}
                            handleBackScreenPage={handleBack}
                            activeFormPageData={activeFormPage}
                            firstPageFirstFormID={firstPageFirstFormID}
                            isLastForm={isLastForm}
                          />
                        </div>
                      ) : activeComponent &&
                        activeComponent?.type === "widget" ? (
                        <div className="flex justify-center content-width ">
                          {activeComponent?.answer &&
                          activeComponent?.answer?.status ===
                            "payment-successful" ? (
                            <div className="">
                              <div className="flex flex-col">
                                <div className="text-center font-semibold text-lg py-3 shadow my-5 px-24 rounded bg-gray-100">
                                  {activeComponent?.answer?.message}
                                </div>
                                <div className="flex justify-between py-8">
                                  <button
                                    disabled={isLoading}
                                    onClick={handleBack}
                                    className="text_button"
                                  >
                                    Back
                                  </button>
                                  <button
                                    disabled={isLoading}
                                    onClick={handleNext}
                                    className="primary_button"
                                  >
                                    Next
                                  </button>
                                </div>
                              </div>
                            </div>
                          ) : (
                            <>
                              <div className="content-width ">
                                <StripeCheckout
                                  org_id={activeComponent?.widget?.org_id}
                                  amount={activeComponent?.widget?.amount || 0}
                                  widget={activeComponent?.widget}
                                  handleNextScreenPage={handleNext}
                                  handleBackScreenPage={handleBack}
                                  setAnswerForWidget={setAnswerForWidget}
                                />
                              </div>
                            </>
                          )}
                        </div>
                      ) : activeComponent &&
                        activeComponent?.type === "scheduler-widget" ? (
                        <div className="flex justify-center">
                          {activeComponent?.answer &&
                          activeComponent?.answer?.status ===
                            "appointment-successful" ? (
                            <div className="content-width">
                              <div className="flex flex-col">
                                <div className="text-center font-semibold text-lg py-3 shadow my-5 px-24 rounded bg-gray-100">
                                  {activeComponent?.answer?.message}
                                </div>
                                <div className="flex justify-between py-8">
                                  <button
                                    disabled={isLoading}
                                    onClick={handleBack}
                                    className="text_button"
                                  >
                                    Back
                                  </button>
                                  <button
                                    disabled={isLoading}
                                    onClick={handleNext}
                                    className="primary_button"
                                  >
                                    Next
                                  </button>
                                </div>
                              </div>
                            </div>
                          ) : (
                            <>
                              <div className="w-full">
                                <SchedulerWidget
                                  widget={activeComponent?.widget}
                                  handleNextScreenPage={handleNext}
                                  handleBackScreenPage={handleBack}
                                  setAnswerForWidget={
                                    setAnswerForSchedulerWidget
                                  }
                                />
                              </div>
                            </>
                          )}
                        </div>
                      ) : (
                        <></>
                      )}
                    </div>
                  </>
                )}
              </>
            ) : (
              <div className="flex flex-col  h-screen justify-center items-center">
                <Loader message={loaderMessage} />
              </div>
            )}
          </div>
        </div>
      )}

      {theme && theme === "themeSynaptrixDemoPartnerTelehealth" && (
        <div className="default-theme">
          <div className="m-auto journey-renderer-container">
            {!isLoading ? (
              <>
                {inActiveAppointment ? (
                  <>
                    <div className="w-auto">
                      <div className="w-auto p-5 text-2xl text-center h-screen bg-gray-100 py-48">
                        Appointment does not exist
                      </div>
                      <div className="bottom-bar-shadow">
                        <div className="flex justify-end pt-3 m-auto bottom-bar w-full">
                          <div
                            onClick={() => navigate("/thank-you")}
                            className="primary_button "
                          >
                            Close
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                ) : (
                  <>
                    <div className="top-bar box-shadow">
                      <div className="flex flex-row justify-between px-3 md:w-full">
                        <div className="text-center font-bold title-text md:w-3/12">
                          {!journeySchema?.hideLabel ? (
                            <span>
                              {journeySchema?.label || "User Journey Form"}
                            </span>
                          ) : (
                            <></>
                          )}
                        </div>
                        <div className="m-auto hidden md:block md:w-6/12">
                          <ProgressTracker
                            steps={steps}
                            currentStep={activeStep}
                          />
                        </div>
                        <div className="my-auto font-semibold md:w-3/12 ">
                          {/* {activeStep + 1} / {steps?.length} */}
                          {/* <img src={ameriGasLogo} className="w-28 mx-auto" /> */}
                          <svg
                            className="w-40 mx-auto"
                            xmlns="http://www.w3.org/2000/svg"
                            width="187"
                            height="40"
                            fill="none"
                            viewBox="0 0 187 40"
                          >
                            <path
                              fill="#3A724F"
                              fill-rule="evenodd"
                              d="M19.87 4.567 22.507 0l7.476 4.317-2.636 4.566c-.463.801.23 1.775 1.138 1.6l5.052-.975 1.635 8.477-5.052.974c-8.172 1.576-14.411-7.184-10.25-14.392Z"
                              clip-rule="evenodd"
                            ></path>
                            <path
                              fill="#DC8E43"
                              fill-rule="evenodd"
                              d="M15.302 35.433 12.665 40l-7.477-4.316 2.637-4.567c.463-.801-.23-1.775-1.139-1.6l-5.051.974L0 22.015l5.052-.974c8.172-1.576 14.41 7.184 10.25 14.392Z"
                              clip-rule="evenodd"
                            ></path>
                            <path
                              fill="#14424C"
                              fill-rule="evenodd"
                              d="M15.53 4.567 12.894 0 5.417 4.317l2.637 4.566c.462.801-.23 1.775-1.139 1.6l-5.052-.975L.23 17.985l5.051.974c8.173 1.576 14.412-7.184 10.25-14.392Z"
                              clip-rule="evenodd"
                            ></path>
                            <path
                              fill="#C85D1B"
                              fill-rule="evenodd"
                              d="M19.65 35.433 22.285 40l7.477-4.316-2.637-4.567c-.462-.801.23-1.775 1.139-1.6l5.051.974 1.635-8.476-5.052-.974c-8.172-1.576-14.41 7.184-10.25 14.392Z"
                              clip-rule="evenodd"
                            ></path>
                            <path
                              fill="#14424C"
                              d="M163.114 30.153v-8.5c0-1.178.271-2.235.813-3.17.561-.954 1.356-1.702 2.385-2.245 1.029-.542 2.254-.813 3.675-.813a7.23 7.23 0 0 1 1.964.252c.599.15 1.141.365 1.627.645.505.262.935.58 1.291.954h.056a5.5 5.5 0 0 1 1.29-.954 6.772 6.772 0 0 1 1.656-.645 7.541 7.541 0 0 1 1.992-.252c1.421 0 2.646.27 3.675.813 1.028.543 1.823 1.29 2.384 2.245.562.935.842 1.991.842 3.17v8.5h-4.377v-8.36c0-.467-.121-.888-.364-1.262a2.663 2.663 0 0 0-.926-.954 2.508 2.508 0 0 0-1.347-.365c-.505 0-.963.122-1.374.365a2.654 2.654 0 0 0-.926.954 2.4 2.4 0 0 0-.337 1.262v8.36h-4.348v-8.36c0-.467-.122-.888-.365-1.262a2.585 2.585 0 0 0-.954-.954 2.508 2.508 0 0 0-1.347-.365c-.505 0-.963.122-1.374.365a2.654 2.654 0 0 0-.926.954 2.41 2.41 0 0 0-.337 1.262v8.36h-4.348ZM153.603 30.49c-1.477 0-2.759-.28-3.843-.842-1.066-.58-1.889-1.356-2.469-2.328-.58-.991-.87-2.086-.87-3.283v-8.276h4.349v8.164c0 .505.121.973.364 1.403.243.411.571.748.982 1.01.43.243.917.365 1.459.365.524 0 .991-.122 1.403-.365.43-.262.767-.599 1.01-1.01.243-.43.365-.898.365-1.403v-8.164h4.348v8.276c0 1.197-.281 2.292-.842 3.283-.561.972-1.374 1.749-2.44 2.328-1.048.561-2.32.842-3.816.842ZM132.414 30.153v-3.45h6.93c.187 0 .355-.038.505-.113.149-.093.271-.215.364-.364a.93.93 0 0 0 0-.982.9.9 0 0 0-.364-.337.934.934 0 0 0-.505-.14h-2.525c-.936 0-1.787-.15-2.553-.449a4.052 4.052 0 0 1-1.796-1.459c-.43-.673-.645-1.543-.645-2.609 0-.823.196-1.571.589-2.244a4.76 4.76 0 0 1 1.655-1.628 4.568 4.568 0 0 1 2.329-.617h6.929v3.479h-6.256a.97.97 0 0 0-.673.253.841.841 0 0 0-.253.617c0 .262.085.486.253.673a.97.97 0 0 0 .673.253h2.469c1.047 0 1.945.159 2.693.476.767.3 1.356.786 1.768 1.46.43.673.645 1.542.645 2.608 0 .842-.215 1.609-.645 2.3a4.613 4.613 0 0 1-1.684 1.656c-.692.412-1.477.617-2.356.617h-7.547ZM122.94 15.425c1.216 0 2.291.196 3.226.589a6.41 6.41 0 0 1 2.413 1.627 6.993 6.993 0 0 1 1.543 2.469c.355.935.533 1.973.533 3.114 0 1.421-.299 2.684-.898 3.787a6.471 6.471 0 0 1-2.412 2.553c-1.029.617-2.226.926-3.591.926-.58 0-1.132-.075-1.656-.224a5.312 5.312 0 0 1-1.402-.646 3.9 3.9 0 0 1-1.038-1.038h-.085v7.66h-4.348V23.223c0-1.59.318-2.965.954-4.124a6.666 6.666 0 0 1 2.693-2.694c1.16-.654 2.516-.981 4.068-.981Zm0 3.759c-.673 0-1.262.168-1.767.505-.487.318-.861.767-1.123 1.347-.261.56-.392 1.197-.392 1.907 0 .711.131 1.347.392 1.908.262.561.636 1.01 1.123 1.347.505.318 1.094.477 1.767.477.673 0 1.253-.16 1.739-.477a3.297 3.297 0 0 0 1.123-1.347c.28-.561.42-1.197.42-1.908 0-.71-.14-1.346-.42-1.907-.262-.58-.636-1.03-1.123-1.347-.486-.337-1.066-.505-1.739-.505ZM108.617 30.153V15.761h4.377v14.392h-4.377Zm2.188-16.019c-.692 0-1.29-.252-1.795-.757-.505-.505-.758-1.104-.758-1.796s.253-1.29.758-1.795c.505-.524 1.103-.786 1.795-.786s1.291.262 1.796.786c.505.505.757 1.103.757 1.795s-.252 1.29-.757 1.796c-.505.505-1.104.757-1.796.757ZM99.105 30.49c-1.477 0-2.805-.327-3.984-.982a7.462 7.462 0 0 1-2.805-2.693c-.673-1.141-1.01-2.422-1.01-3.844 0-1.44.337-2.721 1.01-3.843a7.462 7.462 0 0 1 2.805-2.693c1.179-.674 2.507-1.01 3.984-1.01 1.478 0 2.796.336 3.956 1.01a7.25 7.25 0 0 1 2.777 2.693c.692 1.122 1.038 2.403 1.038 3.843 0 1.422-.346 2.703-1.038 3.844a7.25 7.25 0 0 1-2.777 2.693c-1.178.655-2.497.982-3.956.982Zm0-3.787c.692 0 1.291-.169 1.796-.505a3.424 3.424 0 0 0 1.178-1.347c.281-.561.421-1.197.421-1.908 0-.692-.14-1.318-.421-1.88a3.423 3.423 0 0 0-1.178-1.346c-.505-.337-1.104-.505-1.796-.505s-1.3.168-1.823.505a3.428 3.428 0 0 0-1.179 1.347 4.144 4.144 0 0 0-.42 1.88c0 .71.14 1.346.42 1.907a3.43 3.43 0 0 0 1.179 1.347c.523.336 1.131.505 1.823.505ZM77.174 35.849v-3.732h7.181c.281 0 .515-.093.702-.28a.83.83 0 0 0 .28-.646v-3.17h-.084a6.59 6.59 0 0 1-1.206 1.094c-.412.3-.88.524-1.403.674a6.023 6.023 0 0 1-1.711.224c-1.272 0-2.413-.3-3.423-.898-.991-.617-1.777-1.468-2.357-2.553-.56-1.084-.841-2.319-.841-3.703 0-1.365.29-2.609.87-3.731.598-1.122 1.468-2.02 2.609-2.693 1.14-.674 2.534-1.01 4.18-1.01 1.571 0 2.927.327 4.068.982a6.624 6.624 0 0 1 2.693 2.72c.636 1.16.954 2.526.954 4.097v8.416c0 1.29-.383 2.31-1.15 3.058-.748.767-1.786 1.15-3.114 1.15h-8.248Zm4.825-9.483c.673 0 1.253-.15 1.74-.449a3.18 3.18 0 0 0 1.121-1.262 3.834 3.834 0 0 0 .393-1.74c0-.673-.13-1.29-.392-1.851-.262-.561-.636-1.001-1.123-1.319-.486-.337-1.066-.505-1.74-.505-.654 0-1.234.159-1.739.477-.486.318-.86.748-1.122 1.29-.261.543-.392 1.15-.392 1.824 0 .655.13 1.253.392 1.796.262.523.636.944 1.123 1.262.504.318 1.084.477 1.739.477ZM65.473 30.49c-1.477 0-2.805-.327-3.983-.982a7.46 7.46 0 0 1-2.806-2.693c-.673-1.141-1.01-2.422-1.01-3.844 0-1.44.337-2.721 1.01-3.843a7.46 7.46 0 0 1 2.806-2.693c1.178-.674 2.506-1.01 3.983-1.01 1.478 0 2.796.336 3.956 1.01a7.252 7.252 0 0 1 2.777 2.693c.692 1.122 1.038 2.403 1.038 3.843 0 1.422-.346 2.703-1.038 3.844a7.252 7.252 0 0 1-2.777 2.693c-1.178.655-2.497.982-3.956.982Zm0-3.787c.692 0 1.29-.169 1.796-.505a3.43 3.43 0 0 0 1.178-1.347c.28-.561.42-1.197.42-1.908 0-.692-.14-1.318-.42-1.88a3.429 3.429 0 0 0-1.178-1.346c-.505-.337-1.104-.505-1.796-.505s-1.3.168-1.823.505a3.428 3.428 0 0 0-1.179 1.347 4.145 4.145 0 0 0-.42 1.88c0 .71.14 1.346.42 1.907a3.43 3.43 0 0 0 1.179 1.347c.523.336 1.131.505 1.823.505ZM51.547 30.153c-1.216 0-2.282-.27-3.198-.813a5.763 5.763 0 0 1-2.132-2.16c-.505-.898-.758-1.89-.758-2.974V10.515h4.713v14.027c0 .45.16.842.477 1.179.318.336.71.505 1.178.505h5.19v3.927h-5.47Z"
                            ></path>
                          </svg>
                        </div>
                      </div>
                      <div className="m-auto pt-5 mx-auto md:hidden">
                        <ProgressTracker
                          steps={steps}
                          currentStep={activeStep}
                        />
                      </div>
                    </div>
                    <div className="journey-content content-padding overflow-y-visible">
                      {activeComponent &&
                      activeComponent?.form &&
                      (activeComponent?.type === "user-form" ||
                        activeComponent?.type === "standard-form") ? (
                        <div className="content-width ">
                          <FormRenderer
                            formData={activeComponent}
                            handleNextScreenPage={handleNext}
                            handleBackScreenPage={handleBack}
                            activeFormPageData={activeFormPage}
                            firstPageFirstFormID={firstPageFirstFormID}
                            isLastForm={isLastForm}
                          />
                        </div>
                      ) : activeComponent &&
                        activeComponent?.type === "widget" ? (
                        <div className="flex justify-center content-width ">
                          {activeComponent?.answer &&
                          activeComponent?.answer?.status ===
                            "payment-successful" ? (
                            <div className="">
                              <div className="flex flex-col">
                                <div className="text-center font-semibold text-lg py-3 shadow my-5 px-24 rounded bg-gray-100">
                                  {activeComponent?.answer?.message}
                                </div>
                                <div className="flex justify-between py-8">
                                  <button
                                    disabled={isLoading}
                                    onClick={handleBack}
                                    className="text_button"
                                  >
                                    Back
                                  </button>
                                  <button
                                    disabled={isLoading}
                                    onClick={handleNext}
                                    className="primary_button"
                                  >
                                    Next
                                  </button>
                                </div>
                              </div>
                            </div>
                          ) : (
                            <>
                              <div className="content-width ">
                                <StripeCheckout
                                  org_id={activeComponent?.widget?.org_id}
                                  amount={activeComponent?.widget?.amount || 0}
                                  widget={activeComponent?.widget}
                                  handleNextScreenPage={handleNext}
                                  handleBackScreenPage={handleBack}
                                  setAnswerForWidget={setAnswerForWidget}
                                />
                              </div>
                            </>
                          )}
                        </div>
                      ) : activeComponent &&
                        activeComponent?.type === "scheduler-widget" ? (
                        <div className="flex justify-center">
                          {activeComponent?.answer &&
                          activeComponent?.answer?.status ===
                            "appointment-successful" ? (
                            <div className="content-width">
                              <div className="flex flex-col">
                                <div className="text-center font-semibold text-lg py-3 shadow my-5 px-24 rounded bg-gray-100">
                                  {activeComponent?.answer?.message}
                                </div>
                                <div className="flex justify-between py-8">
                                  <button
                                    disabled={isLoading}
                                    onClick={handleBack}
                                    className="text_button"
                                  >
                                    Back
                                  </button>
                                  <button
                                    disabled={isLoading}
                                    onClick={handleNext}
                                    className="primary_button"
                                  >
                                    Next
                                  </button>
                                </div>
                              </div>
                            </div>
                          ) : (
                            <>
                              <div className="w-full">
                                <SchedulerWidget
                                  widget={activeComponent?.widget}
                                  handleNextScreenPage={handleNext}
                                  handleBackScreenPage={handleBack}
                                  setAnswerForWidget={
                                    setAnswerForSchedulerWidget
                                  }
                                />
                              </div>
                            </>
                          )}
                        </div>
                      ) : (
                        <></>
                      )}
                    </div>
                  </>
                )}
              </>
            ) : (
              <div className="flex flex-col  h-screen justify-center items-center">
                <Loader message={loaderMessage} />
              </div>
            )}
          </div>
        </div>
      )}

      {theme && theme === "themeCancelForAmerigas" && (
        <div className="default-theme">
          <div className="m-auto journey-renderer-container">
            {!isLoading ? (
              <>
                {inActiveAppointment ? (
                  <>
                    <div className="w-auto">
                      <div className="w-auto p-5 text-2xl text-center h-screen bg-gray-100 py-48">
                        Appointment does not exist
                      </div>
                      <div className="bottom-bar-shadow">
                        <div className="flex justify-end pt-3 m-auto bottom-bar w-full">
                          <div
                            onClick={() => navigate("/thank-you")}
                            className="primary_button "
                          >
                            Close
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                ) : (
                  <>
                    <div className="top-bar box-shadow">
                      <div className="flex flex-row justify-between px-3 md:w-full">
                        <div className="m-auto hidden md:block md:w-12/12">
                          <ProgressTracker
                            steps={steps}
                            currentStep={activeStep}
                          />
                        </div>
                      </div>
                      <div className="m-auto pt-5 mx-auto md:hidden">
                        <ProgressTracker
                          steps={steps}
                          currentStep={activeStep}
                        />
                      </div>
                    </div>
                    <div className="journey-content content-padding overflow-y-visible">
                      {activeComponent &&
                      activeComponent?.form &&
                      (activeComponent?.type === "user-form" ||
                        activeComponent?.type === "standard-form") ? (
                        <div className="content-width ">
                          <FormRenderer
                            formData={activeComponent}
                            handleNextScreenPage={handleNext}
                            handleBackScreenPage={handleBack}
                            activeFormPageData={activeFormPage}
                            firstPageFirstFormID={firstPageFirstFormID}
                            isLastForm={isLastForm}
                          />
                        </div>
                      ) : activeComponent &&
                        activeComponent?.type === "widget" ? (
                        <div className="flex justify-center content-width ">
                          {activeComponent?.answer &&
                          activeComponent?.answer?.status ===
                            "payment-successful" ? (
                            <div className="">
                              <div className="flex flex-col">
                                <div className="text-center font-semibold text-lg py-3 shadow my-5 px-24 rounded bg-gray-100">
                                  {activeComponent?.answer?.message}
                                </div>
                                <div className="flex justify-between py-8">
                                  <button
                                    disabled={isLoading}
                                    onClick={handleBack}
                                    className="text_button"
                                  >
                                    Back
                                  </button>
                                  <button
                                    disabled={isLoading}
                                    onClick={handleNext}
                                    className="primary_button"
                                  >
                                    Next
                                  </button>
                                </div>
                              </div>
                            </div>
                          ) : (
                            <>
                              <div className="content-width ">
                                <StripeCheckout
                                  org_id={activeComponent?.widget?.org_id}
                                  amount={activeComponent?.widget?.amount || 0}
                                  widget={activeComponent?.widget}
                                  handleNextScreenPage={handleNext}
                                  handleBackScreenPage={handleBack}
                                  setAnswerForWidget={setAnswerForWidget}
                                />
                              </div>
                            </>
                          )}
                        </div>
                      ) : activeComponent &&
                        activeComponent?.type === "scheduler-widget" ? (
                        <div className="flex justify-center">
                          {activeComponent?.answer &&
                          activeComponent?.answer?.status ===
                            "appointment-successful" ? (
                            <div className="content-width">
                              <div className="flex flex-col">
                                <div className="text-center font-semibold text-lg py-3 shadow my-5 px-24 rounded bg-gray-100">
                                  {activeComponent?.answer?.message}
                                </div>
                                <div className="flex justify-between py-8">
                                  <button
                                    disabled={isLoading}
                                    onClick={handleBack}
                                    className="text_button"
                                  >
                                    Back
                                  </button>
                                  <button
                                    disabled={isLoading}
                                    onClick={handleNext}
                                    className="primary_button"
                                  >
                                    Next
                                  </button>
                                </div>
                              </div>
                            </div>
                          ) : (
                            <>
                              <div className="w-full">
                                <SchedulerWidgetForReschedule
                                  widget={activeComponent?.widget}
                                  handleNextScreenPage={handleNext}
                                  handleBackScreenPage={handleBack}
                                  setAnswerForWidget={
                                    setAnswerForSchedulerWidget
                                  }
                                />
                              </div>
                            </>
                          )}
                        </div>
                      ) : (
                        <></>
                      )}
                    </div>
                  </>
                )}
              </>
            ) : (
              <div className="flex flex-col  h-screen justify-center items-center">
                <Loader message={loaderMessage} />
              </div>
            )}
          </div>
        </div>
      )}
      {theme && theme === "themeCancelForCPAP" && (
        <div className="default-theme">
          <div className="m-auto journey-renderer-container">
            {!isLoading ? (
              <>
                {inActiveAppointment ? (
                  <>
                    <div className="w-auto">
                      <div className="w-auto p-5 text-2xl text-center h-screen bg-gray-100 py-48">
                        Appointment does not exist
                      </div>
                      <div className="bottom-bar-shadow">
                        <div className="flex justify-end pt-3 m-auto bottom-bar w-full">
                          <div
                            onClick={() => navigate("/thank-you")}
                            className="primary_button "
                          >
                            Close
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                ) : (
                  <>
                    <div className="top-bar box-shadow">
                      <div className="flex flex-row justify-between px-3 md:w-full">
                        <div className="text-center font-bold title-text md:w-3/12">
                          {!journeySchema?.hideLabel ? (
                            <span>
                              {journeySchema?.label || "User Journey Form"}
                            </span>
                          ) : (
                            <></>
                          )}
                        </div>
                        <div className="m-auto hidden md:block md:w-6/12">
                          <ProgressTracker
                            steps={steps}
                            currentStep={activeStep}
                          />
                        </div>
                        <div className="my-auto font-semibold md:w-3/12 ">
                          {/* {activeStep + 1} / {steps?.length} */}
                          {journeySchema?.showDummyLogo ? (
                            <svg
                              className="w-40 mx-auto"
                              xmlns="http://www.w3.org/2000/svg"
                              width="187"
                              height="40"
                              fill="none"
                              viewBox="0 0 187 40"
                            >
                              <path
                                fill="#3A724F"
                                fill-rule="evenodd"
                                d="M19.87 4.567 22.507 0l7.476 4.317-2.636 4.566c-.463.801.23 1.775 1.138 1.6l5.052-.975 1.635 8.477-5.052.974c-8.172 1.576-14.411-7.184-10.25-14.392Z"
                                clip-rule="evenodd"
                              ></path>
                              <path
                                fill="#DC8E43"
                                fill-rule="evenodd"
                                d="M15.302 35.433 12.665 40l-7.477-4.316 2.637-4.567c.463-.801-.23-1.775-1.139-1.6l-5.051.974L0 22.015l5.052-.974c8.172-1.576 14.41 7.184 10.25 14.392Z"
                                clip-rule="evenodd"
                              ></path>
                              <path
                                fill="#14424C"
                                fill-rule="evenodd"
                                d="M15.53 4.567 12.894 0 5.417 4.317l2.637 4.566c.462.801-.23 1.775-1.139 1.6l-5.052-.975L.23 17.985l5.051.974c8.173 1.576 14.412-7.184 10.25-14.392Z"
                                clip-rule="evenodd"
                              ></path>
                              <path
                                fill="#C85D1B"
                                fill-rule="evenodd"
                                d="M19.65 35.433 22.285 40l7.477-4.316-2.637-4.567c-.462-.801.23-1.775 1.139-1.6l5.051.974 1.635-8.476-5.052-.974c-8.172-1.576-14.41 7.184-10.25 14.392Z"
                                clip-rule="evenodd"
                              ></path>
                              <path
                                fill="#14424C"
                                d="M163.114 30.153v-8.5c0-1.178.271-2.235.813-3.17.561-.954 1.356-1.702 2.385-2.245 1.029-.542 2.254-.813 3.675-.813a7.23 7.23 0 0 1 1.964.252c.599.15 1.141.365 1.627.645.505.262.935.58 1.291.954h.056a5.5 5.5 0 0 1 1.29-.954 6.772 6.772 0 0 1 1.656-.645 7.541 7.541 0 0 1 1.992-.252c1.421 0 2.646.27 3.675.813 1.028.543 1.823 1.29 2.384 2.245.562.935.842 1.991.842 3.17v8.5h-4.377v-8.36c0-.467-.121-.888-.364-1.262a2.663 2.663 0 0 0-.926-.954 2.508 2.508 0 0 0-1.347-.365c-.505 0-.963.122-1.374.365a2.654 2.654 0 0 0-.926.954 2.4 2.4 0 0 0-.337 1.262v8.36h-4.348v-8.36c0-.467-.122-.888-.365-1.262a2.585 2.585 0 0 0-.954-.954 2.508 2.508 0 0 0-1.347-.365c-.505 0-.963.122-1.374.365a2.654 2.654 0 0 0-.926.954 2.41 2.41 0 0 0-.337 1.262v8.36h-4.348ZM153.603 30.49c-1.477 0-2.759-.28-3.843-.842-1.066-.58-1.889-1.356-2.469-2.328-.58-.991-.87-2.086-.87-3.283v-8.276h4.349v8.164c0 .505.121.973.364 1.403.243.411.571.748.982 1.01.43.243.917.365 1.459.365.524 0 .991-.122 1.403-.365.43-.262.767-.599 1.01-1.01.243-.43.365-.898.365-1.403v-8.164h4.348v8.276c0 1.197-.281 2.292-.842 3.283-.561.972-1.374 1.749-2.44 2.328-1.048.561-2.32.842-3.816.842ZM132.414 30.153v-3.45h6.93c.187 0 .355-.038.505-.113.149-.093.271-.215.364-.364a.93.93 0 0 0 0-.982.9.9 0 0 0-.364-.337.934.934 0 0 0-.505-.14h-2.525c-.936 0-1.787-.15-2.553-.449a4.052 4.052 0 0 1-1.796-1.459c-.43-.673-.645-1.543-.645-2.609 0-.823.196-1.571.589-2.244a4.76 4.76 0 0 1 1.655-1.628 4.568 4.568 0 0 1 2.329-.617h6.929v3.479h-6.256a.97.97 0 0 0-.673.253.841.841 0 0 0-.253.617c0 .262.085.486.253.673a.97.97 0 0 0 .673.253h2.469c1.047 0 1.945.159 2.693.476.767.3 1.356.786 1.768 1.46.43.673.645 1.542.645 2.608 0 .842-.215 1.609-.645 2.3a4.613 4.613 0 0 1-1.684 1.656c-.692.412-1.477.617-2.356.617h-7.547ZM122.94 15.425c1.216 0 2.291.196 3.226.589a6.41 6.41 0 0 1 2.413 1.627 6.993 6.993 0 0 1 1.543 2.469c.355.935.533 1.973.533 3.114 0 1.421-.299 2.684-.898 3.787a6.471 6.471 0 0 1-2.412 2.553c-1.029.617-2.226.926-3.591.926-.58 0-1.132-.075-1.656-.224a5.312 5.312 0 0 1-1.402-.646 3.9 3.9 0 0 1-1.038-1.038h-.085v7.66h-4.348V23.223c0-1.59.318-2.965.954-4.124a6.666 6.666 0 0 1 2.693-2.694c1.16-.654 2.516-.981 4.068-.981Zm0 3.759c-.673 0-1.262.168-1.767.505-.487.318-.861.767-1.123 1.347-.261.56-.392 1.197-.392 1.907 0 .711.131 1.347.392 1.908.262.561.636 1.01 1.123 1.347.505.318 1.094.477 1.767.477.673 0 1.253-.16 1.739-.477a3.297 3.297 0 0 0 1.123-1.347c.28-.561.42-1.197.42-1.908 0-.71-.14-1.346-.42-1.907-.262-.58-.636-1.03-1.123-1.347-.486-.337-1.066-.505-1.739-.505ZM108.617 30.153V15.761h4.377v14.392h-4.377Zm2.188-16.019c-.692 0-1.29-.252-1.795-.757-.505-.505-.758-1.104-.758-1.796s.253-1.29.758-1.795c.505-.524 1.103-.786 1.795-.786s1.291.262 1.796.786c.505.505.757 1.103.757 1.795s-.252 1.29-.757 1.796c-.505.505-1.104.757-1.796.757ZM99.105 30.49c-1.477 0-2.805-.327-3.984-.982a7.462 7.462 0 0 1-2.805-2.693c-.673-1.141-1.01-2.422-1.01-3.844 0-1.44.337-2.721 1.01-3.843a7.462 7.462 0 0 1 2.805-2.693c1.179-.674 2.507-1.01 3.984-1.01 1.478 0 2.796.336 3.956 1.01a7.25 7.25 0 0 1 2.777 2.693c.692 1.122 1.038 2.403 1.038 3.843 0 1.422-.346 2.703-1.038 3.844a7.25 7.25 0 0 1-2.777 2.693c-1.178.655-2.497.982-3.956.982Zm0-3.787c.692 0 1.291-.169 1.796-.505a3.424 3.424 0 0 0 1.178-1.347c.281-.561.421-1.197.421-1.908 0-.692-.14-1.318-.421-1.88a3.423 3.423 0 0 0-1.178-1.346c-.505-.337-1.104-.505-1.796-.505s-1.3.168-1.823.505a3.428 3.428 0 0 0-1.179 1.347 4.144 4.144 0 0 0-.42 1.88c0 .71.14 1.346.42 1.907a3.43 3.43 0 0 0 1.179 1.347c.523.336 1.131.505 1.823.505ZM77.174 35.849v-3.732h7.181c.281 0 .515-.093.702-.28a.83.83 0 0 0 .28-.646v-3.17h-.084a6.59 6.59 0 0 1-1.206 1.094c-.412.3-.88.524-1.403.674a6.023 6.023 0 0 1-1.711.224c-1.272 0-2.413-.3-3.423-.898-.991-.617-1.777-1.468-2.357-2.553-.56-1.084-.841-2.319-.841-3.703 0-1.365.29-2.609.87-3.731.598-1.122 1.468-2.02 2.609-2.693 1.14-.674 2.534-1.01 4.18-1.01 1.571 0 2.927.327 4.068.982a6.624 6.624 0 0 1 2.693 2.72c.636 1.16.954 2.526.954 4.097v8.416c0 1.29-.383 2.31-1.15 3.058-.748.767-1.786 1.15-3.114 1.15h-8.248Zm4.825-9.483c.673 0 1.253-.15 1.74-.449a3.18 3.18 0 0 0 1.121-1.262 3.834 3.834 0 0 0 .393-1.74c0-.673-.13-1.29-.392-1.851-.262-.561-.636-1.001-1.123-1.319-.486-.337-1.066-.505-1.74-.505-.654 0-1.234.159-1.739.477-.486.318-.86.748-1.122 1.29-.261.543-.392 1.15-.392 1.824 0 .655.13 1.253.392 1.796.262.523.636.944 1.123 1.262.504.318 1.084.477 1.739.477ZM65.473 30.49c-1.477 0-2.805-.327-3.983-.982a7.46 7.46 0 0 1-2.806-2.693c-.673-1.141-1.01-2.422-1.01-3.844 0-1.44.337-2.721 1.01-3.843a7.46 7.46 0 0 1 2.806-2.693c1.178-.674 2.506-1.01 3.983-1.01 1.478 0 2.796.336 3.956 1.01a7.252 7.252 0 0 1 2.777 2.693c.692 1.122 1.038 2.403 1.038 3.843 0 1.422-.346 2.703-1.038 3.844a7.252 7.252 0 0 1-2.777 2.693c-1.178.655-2.497.982-3.956.982Zm0-3.787c.692 0 1.29-.169 1.796-.505a3.43 3.43 0 0 0 1.178-1.347c.28-.561.42-1.197.42-1.908 0-.692-.14-1.318-.42-1.88a3.429 3.429 0 0 0-1.178-1.346c-.505-.337-1.104-.505-1.796-.505s-1.3.168-1.823.505a3.428 3.428 0 0 0-1.179 1.347 4.145 4.145 0 0 0-.42 1.88c0 .71.14 1.346.42 1.907a3.43 3.43 0 0 0 1.179 1.347c.523.336 1.131.505 1.823.505ZM51.547 30.153c-1.216 0-2.282-.27-3.198-.813a5.763 5.763 0 0 1-2.132-2.16c-.505-.898-.758-1.89-.758-2.974V10.515h4.713v14.027c0 .45.16.842.477 1.179.318.336.71.505 1.178.505h5.19v3.927h-5.47Z"
                              ></path>
                            </svg>
                          ) : (
                            <img src={cpapLogo} className="w-36 mx-auto" />
                          )}
                        </div>
                      </div>
                      <div className="m-auto pt-5 mx-auto md:hidden">
                        <ProgressTracker
                          steps={steps}
                          currentStep={activeStep}
                        />
                      </div>
                    </div>
                    <div className="journey-content content-padding overflow-y-visible">
                      {activeComponent &&
                      activeComponent?.form &&
                      (activeComponent?.type === "user-form" ||
                        activeComponent?.type === "standard-form") ? (
                        <div className="content-width ">
                          <FormRenderer
                            formData={activeComponent}
                            handleNextScreenPage={handleNext}
                            handleBackScreenPage={handleBack}
                            activeFormPageData={activeFormPage}
                            firstPageFirstFormID={firstPageFirstFormID}
                            isLastForm={isLastForm}
                          />
                        </div>
                      ) : activeComponent &&
                        activeComponent?.type === "widget" ? (
                        <div className="flex justify-center content-width ">
                          {activeComponent?.answer &&
                          activeComponent?.answer?.status ===
                            "payment-successful" ? (
                            <div className="">
                              <div className="flex flex-col">
                                <div className="text-center font-semibold text-lg py-3 shadow my-5 px-24 rounded bg-gray-100">
                                  {activeComponent?.answer?.message}
                                </div>
                                <div className="flex justify-between py-8">
                                  <button
                                    disabled={isLoading}
                                    onClick={handleBack}
                                    className="text_button"
                                  >
                                    Back
                                  </button>
                                  <button
                                    disabled={isLoading}
                                    onClick={handleNext}
                                    className="primary_button"
                                  >
                                    Next
                                  </button>
                                </div>
                              </div>
                            </div>
                          ) : (
                            <>
                              <div className="content-width ">
                                <StripeCheckout
                                  org_id={activeComponent?.widget?.org_id}
                                  amount={activeComponent?.widget?.amount || 0}
                                  widget={activeComponent?.widget}
                                  handleNextScreenPage={handleNext}
                                  handleBackScreenPage={handleBack}
                                  setAnswerForWidget={setAnswerForWidget}
                                />
                              </div>
                            </>
                          )}
                        </div>
                      ) : activeComponent &&
                        activeComponent?.type === "scheduler-widget" ? (
                        <div className="flex justify-center">
                          {activeComponent?.answer &&
                          activeComponent?.answer?.status ===
                            "appointment-successful" ? (
                            <div className="content-width">
                              <div className="flex flex-col">
                                <div className="text-center font-semibold text-lg py-3 shadow my-5 px-24 rounded bg-gray-100">
                                  {activeComponent?.answer?.message}
                                </div>
                                <div className="flex justify-between py-8">
                                  <button
                                    disabled={isLoading}
                                    onClick={handleBack}
                                    className="text_button"
                                  >
                                    Back
                                  </button>
                                  <button
                                    disabled={isLoading}
                                    onClick={handleNext}
                                    className="primary_button"
                                  >
                                    Next
                                  </button>
                                </div>
                              </div>
                            </div>
                          ) : (
                            <>
                              <div className="w-full">
                                <SchedulerWidgetForReschedule
                                  widget={activeComponent?.widget}
                                  handleNextScreenPage={handleNext}
                                  handleBackScreenPage={handleBack}
                                  setAnswerForWidget={
                                    setAnswerForSchedulerWidget
                                  }
                                />
                              </div>
                            </>
                          )}
                        </div>
                      ) : (
                        <></>
                      )}
                    </div>
                  </>
                )}
              </>
            ) : (
              <div className="flex flex-col  h-screen justify-center items-center">
                <Loader message={loaderMessage} />
              </div>
            )}
          </div>
        </div>
      )}
      {theme && theme === "themeCancelForPartnerTelehealth" && (
        <div className="default-theme">
          <div className="m-auto journey-renderer-container">
            {!isLoading ? (
              <>
                {inActiveAppointment ? (
                  <>
                    <div className="w-auto">
                      <div className="w-auto p-5 text-2xl text-center h-screen bg-gray-100 py-48">
                        Appointment does not exist
                      </div>
                      <div className="bottom-bar-shadow">
                        <div className="flex justify-end pt-3 m-auto bottom-bar w-full">
                          <div
                            onClick={() => navigate("/thank-you")}
                            className="primary_button "
                          >
                            Close
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                ) : (
                  <>
                    <div className="top-bar box-shadow">
                      <div className="flex flex-row justify-between px-3 md:w-full">
                        <div className="text-center font-bold title-text md:w-3/12">
                          {!journeySchema?.hideLabel ? (
                            <span>
                              {journeySchema?.label || "User Journey Form"}
                            </span>
                          ) : (
                            <></>
                          )}
                        </div>
                        <div className="m-auto hidden md:block md:w-6/12">
                          <ProgressTracker
                            steps={steps}
                            currentStep={activeStep}
                          />
                        </div>

                        <div className="my-auto font-semibold md:w-3/12 ">
                          {/* {activeStep + 1} / {steps?.length} */}
                          {/* <img src={ameriGasLogo} className="w-28 mx-auto" /> */}
                          <svg
                            className="w-40 mx-auto"
                            xmlns="http://www.w3.org/2000/svg"
                            width="187"
                            height="40"
                            fill="none"
                            viewBox="0 0 187 40"
                          >
                            <path
                              fill="#3A724F"
                              fill-rule="evenodd"
                              d="M19.87 4.567 22.507 0l7.476 4.317-2.636 4.566c-.463.801.23 1.775 1.138 1.6l5.052-.975 1.635 8.477-5.052.974c-8.172 1.576-14.411-7.184-10.25-14.392Z"
                              clip-rule="evenodd"
                            ></path>
                            <path
                              fill="#DC8E43"
                              fill-rule="evenodd"
                              d="M15.302 35.433 12.665 40l-7.477-4.316 2.637-4.567c.463-.801-.23-1.775-1.139-1.6l-5.051.974L0 22.015l5.052-.974c8.172-1.576 14.41 7.184 10.25 14.392Z"
                              clip-rule="evenodd"
                            ></path>
                            <path
                              fill="#14424C"
                              fill-rule="evenodd"
                              d="M15.53 4.567 12.894 0 5.417 4.317l2.637 4.566c.462.801-.23 1.775-1.139 1.6l-5.052-.975L.23 17.985l5.051.974c8.173 1.576 14.412-7.184 10.25-14.392Z"
                              clip-rule="evenodd"
                            ></path>
                            <path
                              fill="#C85D1B"
                              fill-rule="evenodd"
                              d="M19.65 35.433 22.285 40l7.477-4.316-2.637-4.567c-.462-.801.23-1.775 1.139-1.6l5.051.974 1.635-8.476-5.052-.974c-8.172-1.576-14.41 7.184-10.25 14.392Z"
                              clip-rule="evenodd"
                            ></path>
                            <path
                              fill="#14424C"
                              d="M163.114 30.153v-8.5c0-1.178.271-2.235.813-3.17.561-.954 1.356-1.702 2.385-2.245 1.029-.542 2.254-.813 3.675-.813a7.23 7.23 0 0 1 1.964.252c.599.15 1.141.365 1.627.645.505.262.935.58 1.291.954h.056a5.5 5.5 0 0 1 1.29-.954 6.772 6.772 0 0 1 1.656-.645 7.541 7.541 0 0 1 1.992-.252c1.421 0 2.646.27 3.675.813 1.028.543 1.823 1.29 2.384 2.245.562.935.842 1.991.842 3.17v8.5h-4.377v-8.36c0-.467-.121-.888-.364-1.262a2.663 2.663 0 0 0-.926-.954 2.508 2.508 0 0 0-1.347-.365c-.505 0-.963.122-1.374.365a2.654 2.654 0 0 0-.926.954 2.4 2.4 0 0 0-.337 1.262v8.36h-4.348v-8.36c0-.467-.122-.888-.365-1.262a2.585 2.585 0 0 0-.954-.954 2.508 2.508 0 0 0-1.347-.365c-.505 0-.963.122-1.374.365a2.654 2.654 0 0 0-.926.954 2.41 2.41 0 0 0-.337 1.262v8.36h-4.348ZM153.603 30.49c-1.477 0-2.759-.28-3.843-.842-1.066-.58-1.889-1.356-2.469-2.328-.58-.991-.87-2.086-.87-3.283v-8.276h4.349v8.164c0 .505.121.973.364 1.403.243.411.571.748.982 1.01.43.243.917.365 1.459.365.524 0 .991-.122 1.403-.365.43-.262.767-.599 1.01-1.01.243-.43.365-.898.365-1.403v-8.164h4.348v8.276c0 1.197-.281 2.292-.842 3.283-.561.972-1.374 1.749-2.44 2.328-1.048.561-2.32.842-3.816.842ZM132.414 30.153v-3.45h6.93c.187 0 .355-.038.505-.113.149-.093.271-.215.364-.364a.93.93 0 0 0 0-.982.9.9 0 0 0-.364-.337.934.934 0 0 0-.505-.14h-2.525c-.936 0-1.787-.15-2.553-.449a4.052 4.052 0 0 1-1.796-1.459c-.43-.673-.645-1.543-.645-2.609 0-.823.196-1.571.589-2.244a4.76 4.76 0 0 1 1.655-1.628 4.568 4.568 0 0 1 2.329-.617h6.929v3.479h-6.256a.97.97 0 0 0-.673.253.841.841 0 0 0-.253.617c0 .262.085.486.253.673a.97.97 0 0 0 .673.253h2.469c1.047 0 1.945.159 2.693.476.767.3 1.356.786 1.768 1.46.43.673.645 1.542.645 2.608 0 .842-.215 1.609-.645 2.3a4.613 4.613 0 0 1-1.684 1.656c-.692.412-1.477.617-2.356.617h-7.547ZM122.94 15.425c1.216 0 2.291.196 3.226.589a6.41 6.41 0 0 1 2.413 1.627 6.993 6.993 0 0 1 1.543 2.469c.355.935.533 1.973.533 3.114 0 1.421-.299 2.684-.898 3.787a6.471 6.471 0 0 1-2.412 2.553c-1.029.617-2.226.926-3.591.926-.58 0-1.132-.075-1.656-.224a5.312 5.312 0 0 1-1.402-.646 3.9 3.9 0 0 1-1.038-1.038h-.085v7.66h-4.348V23.223c0-1.59.318-2.965.954-4.124a6.666 6.666 0 0 1 2.693-2.694c1.16-.654 2.516-.981 4.068-.981Zm0 3.759c-.673 0-1.262.168-1.767.505-.487.318-.861.767-1.123 1.347-.261.56-.392 1.197-.392 1.907 0 .711.131 1.347.392 1.908.262.561.636 1.01 1.123 1.347.505.318 1.094.477 1.767.477.673 0 1.253-.16 1.739-.477a3.297 3.297 0 0 0 1.123-1.347c.28-.561.42-1.197.42-1.908 0-.71-.14-1.346-.42-1.907-.262-.58-.636-1.03-1.123-1.347-.486-.337-1.066-.505-1.739-.505ZM108.617 30.153V15.761h4.377v14.392h-4.377Zm2.188-16.019c-.692 0-1.29-.252-1.795-.757-.505-.505-.758-1.104-.758-1.796s.253-1.29.758-1.795c.505-.524 1.103-.786 1.795-.786s1.291.262 1.796.786c.505.505.757 1.103.757 1.795s-.252 1.29-.757 1.796c-.505.505-1.104.757-1.796.757ZM99.105 30.49c-1.477 0-2.805-.327-3.984-.982a7.462 7.462 0 0 1-2.805-2.693c-.673-1.141-1.01-2.422-1.01-3.844 0-1.44.337-2.721 1.01-3.843a7.462 7.462 0 0 1 2.805-2.693c1.179-.674 2.507-1.01 3.984-1.01 1.478 0 2.796.336 3.956 1.01a7.25 7.25 0 0 1 2.777 2.693c.692 1.122 1.038 2.403 1.038 3.843 0 1.422-.346 2.703-1.038 3.844a7.25 7.25 0 0 1-2.777 2.693c-1.178.655-2.497.982-3.956.982Zm0-3.787c.692 0 1.291-.169 1.796-.505a3.424 3.424 0 0 0 1.178-1.347c.281-.561.421-1.197.421-1.908 0-.692-.14-1.318-.421-1.88a3.423 3.423 0 0 0-1.178-1.346c-.505-.337-1.104-.505-1.796-.505s-1.3.168-1.823.505a3.428 3.428 0 0 0-1.179 1.347 4.144 4.144 0 0 0-.42 1.88c0 .71.14 1.346.42 1.907a3.43 3.43 0 0 0 1.179 1.347c.523.336 1.131.505 1.823.505ZM77.174 35.849v-3.732h7.181c.281 0 .515-.093.702-.28a.83.83 0 0 0 .28-.646v-3.17h-.084a6.59 6.59 0 0 1-1.206 1.094c-.412.3-.88.524-1.403.674a6.023 6.023 0 0 1-1.711.224c-1.272 0-2.413-.3-3.423-.898-.991-.617-1.777-1.468-2.357-2.553-.56-1.084-.841-2.319-.841-3.703 0-1.365.29-2.609.87-3.731.598-1.122 1.468-2.02 2.609-2.693 1.14-.674 2.534-1.01 4.18-1.01 1.571 0 2.927.327 4.068.982a6.624 6.624 0 0 1 2.693 2.72c.636 1.16.954 2.526.954 4.097v8.416c0 1.29-.383 2.31-1.15 3.058-.748.767-1.786 1.15-3.114 1.15h-8.248Zm4.825-9.483c.673 0 1.253-.15 1.74-.449a3.18 3.18 0 0 0 1.121-1.262 3.834 3.834 0 0 0 .393-1.74c0-.673-.13-1.29-.392-1.851-.262-.561-.636-1.001-1.123-1.319-.486-.337-1.066-.505-1.74-.505-.654 0-1.234.159-1.739.477-.486.318-.86.748-1.122 1.29-.261.543-.392 1.15-.392 1.824 0 .655.13 1.253.392 1.796.262.523.636.944 1.123 1.262.504.318 1.084.477 1.739.477ZM65.473 30.49c-1.477 0-2.805-.327-3.983-.982a7.46 7.46 0 0 1-2.806-2.693c-.673-1.141-1.01-2.422-1.01-3.844 0-1.44.337-2.721 1.01-3.843a7.46 7.46 0 0 1 2.806-2.693c1.178-.674 2.506-1.01 3.983-1.01 1.478 0 2.796.336 3.956 1.01a7.252 7.252 0 0 1 2.777 2.693c.692 1.122 1.038 2.403 1.038 3.843 0 1.422-.346 2.703-1.038 3.844a7.252 7.252 0 0 1-2.777 2.693c-1.178.655-2.497.982-3.956.982Zm0-3.787c.692 0 1.29-.169 1.796-.505a3.43 3.43 0 0 0 1.178-1.347c.28-.561.42-1.197.42-1.908 0-.692-.14-1.318-.42-1.88a3.429 3.429 0 0 0-1.178-1.346c-.505-.337-1.104-.505-1.796-.505s-1.3.168-1.823.505a3.428 3.428 0 0 0-1.179 1.347 4.145 4.145 0 0 0-.42 1.88c0 .71.14 1.346.42 1.907a3.43 3.43 0 0 0 1.179 1.347c.523.336 1.131.505 1.823.505ZM51.547 30.153c-1.216 0-2.282-.27-3.198-.813a5.763 5.763 0 0 1-2.132-2.16c-.505-.898-.758-1.89-.758-2.974V10.515h4.713v14.027c0 .45.16.842.477 1.179.318.336.71.505 1.178.505h5.19v3.927h-5.47Z"
                            ></path>
                          </svg>
                        </div>
                      </div>
                      <div className="m-auto pt-5 mx-auto md:hidden">
                        <ProgressTracker
                          steps={steps}
                          currentStep={activeStep}
                        />
                      </div>
                    </div>
                    <div className="journey-content content-padding overflow-y-visible">
                      {activeComponent &&
                      activeComponent?.form &&
                      (activeComponent?.type === "user-form" ||
                        activeComponent?.type === "standard-form") ? (
                        <div className="content-width ">
                          <FormRenderer
                            formData={activeComponent}
                            handleNextScreenPage={handleNext}
                            handleBackScreenPage={handleBack}
                            activeFormPageData={activeFormPage}
                            firstPageFirstFormID={firstPageFirstFormID}
                            isLastForm={isLastForm}
                          />
                        </div>
                      ) : activeComponent &&
                        activeComponent?.type === "widget" ? (
                        <div className="flex justify-center content-width ">
                          {activeComponent?.answer &&
                          activeComponent?.answer?.status ===
                            "payment-successful" ? (
                            <div className="">
                              <div className="flex flex-col">
                                <div className="text-center font-semibold text-lg py-3 shadow my-5 px-24 rounded bg-gray-100">
                                  {activeComponent?.answer?.message}
                                </div>
                                <div className="flex justify-between py-8">
                                  <button
                                    disabled={isLoading}
                                    onClick={handleBack}
                                    className="text_button"
                                  >
                                    Back
                                  </button>
                                  <button
                                    disabled={isLoading}
                                    onClick={handleNext}
                                    className="primary_button"
                                  >
                                    Next
                                  </button>
                                </div>
                              </div>
                            </div>
                          ) : (
                            <>
                              <div className="content-width ">
                                <StripeCheckout
                                  org_id={activeComponent?.widget?.org_id}
                                  amount={activeComponent?.widget?.amount || 0}
                                  widget={activeComponent?.widget}
                                  handleNextScreenPage={handleNext}
                                  handleBackScreenPage={handleBack}
                                  setAnswerForWidget={setAnswerForWidget}
                                />
                              </div>
                            </>
                          )}
                        </div>
                      ) : activeComponent &&
                        activeComponent?.type === "scheduler-widget" ? (
                        <div className="flex justify-center">
                          {activeComponent?.answer &&
                          activeComponent?.answer?.status ===
                            "appointment-successful" ? (
                            <div className="content-width">
                              <div className="flex flex-col">
                                <div className="text-center font-semibold text-lg py-3 shadow my-5 px-24 rounded bg-gray-100">
                                  {activeComponent?.answer?.message}
                                </div>
                                <div className="flex justify-between py-8">
                                  <button
                                    disabled={isLoading}
                                    onClick={handleBack}
                                    className="text_button"
                                  >
                                    Back
                                  </button>
                                  <button
                                    disabled={isLoading}
                                    onClick={handleNext}
                                    className="primary_button"
                                  >
                                    Next
                                  </button>
                                </div>
                              </div>
                            </div>
                          ) : (
                            <>
                              <div className="w-full">
                                <SchedulerWidgetForReschedule
                                  widget={activeComponent?.widget}
                                  handleNextScreenPage={handleNext}
                                  handleBackScreenPage={handleBack}
                                  setAnswerForWidget={
                                    setAnswerForSchedulerWidget
                                  }
                                />
                              </div>
                            </>
                          )}
                        </div>
                      ) : (
                        <></>
                      )}
                    </div>
                  </>
                )}
              </>
            ) : (
              <div className="flex flex-col  h-screen justify-center items-center">
                <Loader message={loaderMessage} />
              </div>
            )}
          </div>
        </div>
      )}
      {theme && theme === "alternaSleep" && (
        <div className="default-theme alterna-sleep-theme">
          <div className="m-auto journey-renderer-container journey-renderer-container-alterna">
            {!isLoading ? (
              <>
                <div className="journey-content content-padding content-padding-alterna overflow-y-visible journey-content-alterna">
                  <div className="flex items-center justify-center p-4 pb-10 ">
                    <img
                      src="https://hbx-assets.s3.us-east-1.amazonaws.com/journeys/Alterna/Alterna+Sleep+Logo+Blue+Updated.673aa09d481da8.68214576.png"
                      alt="Alterna Sleep Logo Blue"
                      className="w-48 h-auto rounded-md"
                    />
                  </div>
                  {activeComponent &&
                  activeComponent?.form &&
                  (activeComponent?.type === "user-form" ||
                    activeComponent?.type === "standard-form") ? (
                    <div className="content-width content-width-alterna ">
                      <FormRendererNew
                        formData={activeComponent}
                        handleNextScreenPage={handleNext}
                        handleBackScreenPage={handleBack}
                        activeFormPageData={activeFormPage}
                        firstPageFirstFormID={firstPageFirstFormID}
                        isLastForm={isLastForm}
                      />
                    </div>
                  ) : activeComponent && activeComponent?.type === "widget" ? (
                    <div className="flex justify-center content-width content-width-alterna ">
                      {activeComponent?.answer &&
                      activeComponent?.answer?.status ===
                        "payment-successful" ? (
                        <div className="">
                          <div className="flex flex-col">
                            <div className="text-center font-semibold text-lg py-3 shadow my-5 px-24 rounded bg-gray-100">
                              {activeComponent?.answer?.message}
                            </div>
                            <div className="flex justify-between py-8">
                              <button
                                disabled={isLoading}
                                onClick={handleBack}
                                className="text_button"
                              >
                                Back
                              </button>
                              <button
                                disabled={isLoading}
                                onClick={handleNext}
                                className="primary_button"
                              >
                                Next
                              </button>
                            </div>
                          </div>
                        </div>
                      ) : (
                        <>
                          <div className=" content-width content-width-alterna ">
                            <StripeCheckout
                              org_id={activeComponent?.widget?.org_id}
                              amount={activeComponent?.widget?.amount || 0}
                              widget={activeComponent?.widget}
                              handleNextScreenPage={handleNext}
                              handleBackScreenPage={handleBack}
                              setAnswerForWidget={setAnswerForWidget}
                            />
                          </div>
                        </>
                      )}
                    </div>
                  ) : activeComponent &&
                    activeComponent?.type === "scheduler-widget" ? (
                    <div className="flex justify-center">
                      {activeComponent?.answer &&
                      activeComponent?.answer?.status ===
                        "appointment-successful" ? (
                        <div className="content-width content-width-alterna">
                          <div className="flex flex-col">
                            <div className="text-center font-semibold text-lg py-3 shadow my-5 px-24 rounded bg-gray-100">
                              {activeComponent?.answer?.message}
                            </div>
                            <div className="flex justify-between py-8">
                              <button
                                disabled={isLoading}
                                onClick={handleBack}
                                className="text_button"
                              >
                                Back
                              </button>
                              <button
                                disabled={isLoading}
                                onClick={handleNext}
                                className="primary_button"
                              >
                                Next
                              </button>
                            </div>
                          </div>
                        </div>
                      ) : (
                        <>
                          <div className="w-full">
                            <SchedulerWidget
                              widget={activeComponent?.widget}
                              handleNextScreenPage={handleNext}
                              handleBackScreenPage={handleBack}
                              setAnswerForWidget={setAnswerForSchedulerWidget}
                            />
                          </div>
                        </>
                      )}
                    </div>
                  ) : (
                    <></>
                  )}
                </div>
              </>
            ) : (
              <div className="flex flex-col  h-screen justify-center items-center">
                <Loader message={loaderMessage} />
              </div>
            )}
          </div>
        </div>
      )}
      {theme && theme === "midwestDental" && (
        <div className="midwest-dental-theme">
          <div className="m-auto journey-renderer-container">
            {!isLoading ? (
              <>
                {showMidwestThankYou ? (
                  <MidwestDentalThankYouScreen
                    steps={steps}
                    deviceType={deviceType}
                    configs={journeyConfigs}
                    firstName={workflowContext?.firstName}
                    location={workflowContext?.location}
                    contactPhone={journeyConfigs?.phone || "(312) 676-9892"}
                    contactEmail={
                      journeyConfigs?.email || "info@midwestdentalsleep.com"
                    }
                    onSchedule={() => submitFinalJourney(journeyData, false)}
                    onBack={handleThankYouGoBack}
                  />
                ) : showEntryPage ? (
                  <MidwestDentalEntryPage
                    configs={journeyConfigs}
                    onStart={handleMidwestEntryStart}
                    deviceType={deviceType}
                    steps={steps}
                  />
                ) : (
                  <>
                    {showDisclaimerScreen && (
                      <MidwestDentalDisclaimerScreen
                        disclaimerConfig={disclaimerConfig}
                        onGoBack={handleDisclaimerGoBack}
                        onSubmit={async () => {
                          await submitFinalJourney(journeyData, false);
                          navigate("/thank-you");
                        }}
                        steps={steps}
                        currentStep={activeStep}
                        deviceType={deviceType}
                        configs={journeyConfigs}
                        firstName={workflowContext?.firstName}
                      />
                    )}
                    <div
                      className="midwest-dental-form-layout"
                      style={{
                        display: showDisclaimerScreen ? "none" : undefined,
                      }}
                    >
                      {/* Fixed Header with Progress Tracker */}
                      <div className="midwest-dental-fixed-header">
                        <MidwestDentalProgressTracker
                          steps={steps}
                          currentStep={activeStep}
                          deviceType={deviceType}
                        />
                      </div>

                      {/* Scrollable Content */}
                      <div className="midwest-dental-content-area">
                        {activeComponent &&
                        activeComponent?.form &&
                        (activeComponent?.type === "user-form" ||
                          activeComponent?.type === "standard-form") ? (
                          <>
                            <FormRenderer
                              formData={activeComponent}
                              handleNextScreenPage={handleMidwestDentalNext}
                              handleBackScreenPage={handleMidwestDentalBack}
                              activeFormPageData={activeFormPage}
                              firstPageFirstFormID={firstPageFirstFormID}
                              isLastForm={false}
                              formClass="midwest-dental-form"
                              showBackOnFirstPage={true}
                              logo={journeyConfigs?.logo}
                            />
                          </>
                        ) : (
                          <></>
                        )}
                      </div>
                    </div>
                  </>
                )}
              </>
            ) : (
              <div className="flex flex-col h-screen justify-center items-center">
                <Loader message={loaderMessage} />
              </div>
            )}
          </div>
        </div>
      )}
      <ErrorModal
        show={showErrorModal}
        message={errorMessage}
        countdownValue={countdownValue}
      />
      {/* Alterna Sleep Popup */}
      <AlternaSleepPopup />
      {showMidwestRedirectPopup && (
        <div
          className="fixed inset-0 flex items-center justify-center z-50"
          style={{ backgroundColor: "rgba(0, 0, 0, 0.6)" }}
        >
          <div
            className="bg-white rounded-lg p-8 mx-4 text-center shadow-2xl"
            style={{ width: "500px", maxWidth: "90vw" }}
          >
            <div className="mb-4 flex justify-center">
              <svg
                className="w-16 h-16 text-blue-500 animate-spin"
                fill="none"
                viewBox="0 0 24 24"
              >
                <circle
                  className="opacity-25"
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="currentColor"
                  strokeWidth="4"
                />
                <path
                  className="opacity-75"
                  fill="currentColor"
                  d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
                />
              </svg>
            </div>
            <h2 className="text-xl font-semibold mb-2">Redirecting...</h2>
            <p className="text-gray-600">
              Redirecting you to the scheduling page.
            </p>
          </div>
        </div>
      )}
    </div>
  );
};
export default JourneyRenderer;
